'use strict'
exports.default = {
  common: {
    zh: '简体中文',
    tw: '繁體中文',
    ja: '日本語',
    en: 'English',
    ko: '한국어',
    title: '后台管理系统',
    exit: '退出',
    search: '搜索',
    tel: '电话',
    address: '地址',
    scenicSpotAreaSelection: '景点地区选择',
    inputRequiredTip: '请输入景点名称',
    edit: '编辑',
    delete: '删除',
    recommend: '设为推荐',
    pay: '支付',
    printOrder: '打印订单',
    download: '下载',
    cancelRecommend: '取消推荐',
    cancel: '取消',
    confirm: '确定',
    submit: '提交',
    searchMore: '查看更多',
    prompt: '提示',
    basicInfo: '基本信息',
    day: '天',
    hour: '小时',
    minute: '分',
    second: '秒'
  },
  title: {
    supplement: '使用流程补充',
    addDining: '添加产品 (餐厅)',
    balanceSetting: '余额管理',
    productPriceNumber: '库存价格',
    productState: '产品审核',
    productAll: '全部',
    productStated: '待审核',
    productNotState: '审核不通过',
    orderReport: '订单管理',
    orderDetail: '订单详情',
    scenicSpotList: '景点管理',
    addScenicSpot: '添加景点',
    editScenicSpot: '编辑景点',
    scenicSpotDetail: '景点详情',
    productManager: '产品管理',
    pdfFilesManage: 'PDF文件库管理',
    supplyManageProduct: '产品售卖管理',
    tocDistributorManageProduct: 'TOC产品售卖管理',
    pdfBatchList: '批次列表',
    bulkPurchaseList: '批量采购列表',
    bulkPurchaseDetail: '批量采购详情',
    submitAndPayOrderBatch: '批量采购',
    batchPdfFilesList: '批次文件列表',
    addPdfFiles: '添加PDF文件库',
    importPdf: 'PDF文件导入',
    pdfFiles: 'PDF文件',
    DiningDetail: '餐厅产品详情',
    financeStatement: '自动生成财务报表',
    statementDetail: '报表详情',
    warehouse: '仓库管理',
    ticketDepot: '票仓管理',
    addTicketDepot: '新增票仓',
    importTicket: '入仓',
    pinTicket: '验证销票',
    pinTicketMagn: '验证销票管理',
    trades: '交易明细',
    record: '历史提现记录',
    counter: '柜台管理',
    addCounter: '添加柜台',
    editCounter: '编辑柜台',
    liaison: '联络人管理',
    addLiaison: '添加联络人',
    editLiaison: '编辑联络人',
    updatePDFfiles: '编辑PDF文件库',
    importThirdSystemProduct: '产品导入管理',
    productLogList: '产品修改记录',
    productLogDetail: '产品变更详情',
    productLanguageLogList: '产品修改记录',
    productLanguageLogDetail: '产品多语言变更详情'
  },
  lable: {
    selectLogType: '选择查找类型',
    selectLogType_1: '基础字段',
    selectLogType_2: '多语言字段',
    inputProductId: '请输入产品ID',
    inputProductId_placeholder: '请输入产品ID',
    customerDataType: '客人资料类型',
    customerDataInfo: '客人资料信息',
    chooseProductLanguage: '请选择产品语言',
    newOrderEmail: '订单通知邮箱',
    batchStatus: '批次状态',
    proofPath: '凭证链接',
    pinTicketNum: '核销数量',
    KlookTicketCanbeUsedDateTBList: ' 起6个月内',
    KlookTicketCanbeUsedDate: ' 起6个月以内，相同价格梯度的日期有效',
    QuantityMismatch: '销票数与实际购买数量不符，是否继续销票',
    importProduct: '导入产品',
    system: '对接系统',
    chooseSystem: '请选择对接系统',
    klook: '客路系统',
    link: 'LINK',
    thirdNum: '第三方产品编号',
    enterThirdNum: '请输入第三方产品编号',
    thirdProductTime: '时间：',
    timeTips: '请输入时间段（1～24）',
    haveInventory: '有库存',
    noInventory: '无库存',
    travlerFirstName: '游客名',
    travlerFamilyName: '游客姓',
    travlerCall: '称呼',
    enterGolfCourseCode: '请输入高尔夫场地编号',
    enterPrefecture: '请输入行政区域编号',
    Mr: '先生',
    Ms: '女士',
    Miss: '小姐',
    Mrs: '夫人',
    duration: '持续时间',
    travellers: '提示旅客人数',
    voucherUsage: '凭证使用方法',
    voucherTypeDesc: '凭证类型',
    voucherValidity: '凭证有效期限',
    redemptionProcess: '验证流程',
    transportation: '交通方式',
    insiderTips: '温馨提示',
    packageOptions: '套餐说明',
    itinerary: '行程说明',
    joinAstrict: '参加限制',
    demand: '要求',
    additionalInformation: '附加信息',
    meetUpLocation: '集合说明',
    pickUpLocation: '领取地址',
    surcharge: '超时费用',
    location: '地址',
    submitOrderTip: '该产品为特殊产品,提交订单后将自动支付,是否提交?',
    submitOrderBatch: '请确认采购内容无误，提交订单后将自动扣除分销商余额，是否提交?',
    location_placeholder: '请输入地址',
    duration_placeholder: '请输入活动时长',
    productConfirmType_placeholder: '请输入确认类型',
    transportation_placeholder: '请输入交通方式',
    voucherTypeDesc_placeholder: '请输入凭证类型',
    voucherUsage_placeholder: '请输入凭证使用方法',
    voucherValidity_placeholder: '请输入凭证有效期',
    pickUpLocation_placeholder: '请输入领取地址',
    redemptionProcess_placeholder: '请输入地址',
    packageOptions_placeholder: '请输入套餐说明',
    itinerary_placeholder: '请输入行程说明',
    additionalInformation_placeholder: '请输入附加信息',
    surcharge_placeholder: '请输入超时费用',
    insiderTips_placeholder: '请输入温馨提示',
    updateType: '类型修改',
    shareQrCode: '分享二维码',
    setQrCode: '设置二维码',
    addCoupon: '添加优惠券',
    couponName: '优惠券名称',
    couponAmount: '优惠金额',
    couponOrder: '优惠券订单',
    couponCode: '优惠码',
    addCouponCode: '添加优惠码',
    downloadCouponCode: '优惠码下载',
    batchDelete: '批量删除',
    downloadNow: '{cnt}条记录添加成功，是否立即下载?',
    tipMessage1: '请输入名称',
    examine: '分销审核',
    revenueManagement: '分销管理',
    revenueDetail: '收益管理',
    cashManager: '提现管理',
    productState: '状态选择',
    orderNum1: '排序',
    netError: '无法获取该产品信息,系统已自动下线该产品!',
    updateProduct: '更新',
    addProduct: '添加产品',
    addQrCode: '添加二维码',
    pleasechoice: '请选择',
    identity: '身份证',
    studentId: '学生证',
    officerId: '军官证',
    passport: '护照',
    residence: '户口本(儿童请选择此项)',
    hongKongandMacaopass: '港澳通行证',
    cellsyndrome: '台胞证',
    identificationNumber: '证件号码',
    children: '（儿童输入出生年月日）',
    addressinformation: '地址信息',
    expressaddress: '快递地址',
    postalCode: '邮政编码',
    suborderinformation: '子订单信息',
    subordersId: '子订单ID',
    qxzfbcplx: '请选择发布产品类型',
    selectTreeId: '请选择产品类型',
    ticketType: '类型',
    jtrticketType: '类型',
    productPriceTypeSetting: '价格种类设置',
    batchPriceRuleSetting: '批量价格规则设置',
    specificDatePriceSetting: '特定日期价格设置',
    currentProducts: '当前产品：',
    currentProducts_saleDate: '当前产品上架时间段：',
    unlimited: '无限制',
    setProductInventoryAndPrice: '批量设置产品库存和价格',
    setProductPriceType: '设置产品价格种类',
    serialNumber: '序号',
    period: '时间段',
    timelimit: '时间范围',
    selectDateRange: '选择日期范围',
    selectTimeRange: '选择时间范围',
    inventory: '库存',
    purchasePrice: '采购价',
    jtrDistributionPrice: '分销平台采购价',
    stockNum: '场次库存',
    distributionPrice: '分销价',
    marketPrice: '市场价',
    retailPrice: '零售价',
    operating: '操作',
    delete: '删除',
    chargeback: '退单',
    addTimePeriod: '添加时间段',
    reset: '重置',
    save: '保存',
    goBack: '返回',
    confirm: '确认',
    confirmOrder: '确认订单',
    confirmOrder1: '北海道确认订单',
    jtrconfirmOrder: 'JTR确认订单',
    refuse: '拒绝订单',
    cancelOrder: '取消订单',
    requestCancel: '申请取消',
    specialRequestRefund: '特殊申请退款',
    requestRefund: '申请退款',
    makeSure: '确定',
    cancel: '取消',
    productName: '产品名称',
    scene: '场次',
    dataSource: '数据源',
    selectDistributor: '选择分销商',
    authorizedMerchant: '已授权商户',
    businessName: '商户名称',
    priceFloatRange: '分销价授权',
    distributorNameOrNumber: '商户名称/编号',
    distributorNumber: '分销商编号',
    distributorName: '商户名称',
    changeValidTime: '变更有效期',
    // suoCountry: '所属城市',
    suoCountry: '关键字',
    suoCountrys: '关键字',
    productNameOrId: '产品名称/编号',
    productNameOrIds: '产品名称/编号',
    productNameOrIdRemark: '产品名称/编号/备注',
    productDiff: '产品类别',
    productDiffs: '产品类别',
    confirmMethod: '确认方法',
    managerArea: '管理地区',
    productCode: '产品编号',
    golfCourseCode: '高尔夫场地编号',
    prefecture: '地方行政区域',
    suoCity: '所属城市',
    confirmMethods: '确认方法',
    confirmMethodss: '确认方法',
    managerAreas: '管理地区',
    different: '类别',
    number: '人数',
    status: '状态',
    ticketType0: '电子票',
    ticketType1: '实体票',
    ticketType2: '体验',
    ticketType22: '体验',
    ticketType3: '一日游/多日游',
    ticketType33: '一日游/多日游',
    ticketType4: 'Wi-Fi',
    ticketType5: 'SIM卡',
    ticketType6: '美食',
    ticketType66: '美食',
    ticketType7: '交通',
    ticketType77: '交通',
    ticketType8: '优惠套票',
    ticketType88: '优惠套票',
    ticketType9: '夜间巴士',
    ticketType99: '夜间巴士',
    jtrticketType0: '门票',
    jtrticketType1: '套餐或打包产品',
    jtrticketType2: '自由行',
    jtrticketType3: '线路',
    jtrticketType12: '预售',
    isOnlinePay0: '线下',
    isOnlinePay1: '线上',
    isOnlinePay2: '在线支付（预付）',
    isOnlinePay3: '酒店前台现付（返佣）',
    confirmType0: '自动确认',
    confirmType00: '自动确认',
    confirmType1: '二次确认',
    confirmType11: '二次确认',
    confirmType12: '二次确认',
    confirmType2: '',
    productSource0: 'JPH产品',
    productSource1: '合作商产品',
    status0: '待审核',
    status1: '审核通过',
    status2: '审核不通过',
    status3: '下线',
    status4: '草稿',
    checkAll: '查看',
    faverite0: '推荐',
    faverite1: '不推荐',
    toldAllLeft: '说明：使用日期的',
    toldAllMiddle: '天前的',
    toldAllMiddles: '天前的',
    toldAllRight: '之前预定',
    orderEmergentTag: '紧急处理',
    orderUncertainTag: '待确认',
    orderConfirmedTag: '已确认',
    orderCancellingTag: '取消中',
    orderCanceledTag: '已取消',
    orderCompletedTag: '已完成',
    orderExpiredTag: '已过期',
    orderPaymentTag: '已支付（JTR）',
    orderRefundedRequestTag: '已申请退款（JTR）',
    orderRefundedTag: '已退款',
    orderUnpaidTag: '未支付',
    otherSelection: '其它筛选',
    remark: '备注',
    createRoleRemark: '备注',
    productHighlights: '亮点',
    currentState: '当前状态',
    youHave: '您还有',
    processOrder: '来处理此订单',
    toPayOrder: '来支付此订单',
    OrderHistory: '订单历史',
    orderDisExplain: '订单说明(仅分销商自己可见)',
    orderDisExplains: '备注(仅供应商自己可见)',
    CustomersInvisible: '备注（与供应商沟通用）',
    SupplierInvisible: '顾客留言',
    addRemark: '添加备注',
    addMessage: '添加留言',
    addExplain: '编辑说明',
    confirmation: '确定确认此订单吗',
    confirmationPdf: '确认作废此PDF吗',
    confirmationticket: '确认作废此实体票吗',
    specialRefundConfirm: '确认退款后钱款将会全额返还给分销商,是否确认',
    specialRefundCancel: '拒绝退款则订单会继续进行下去',
    DeleteConfirmation: '确定删除吗',
    refusal: '确定拒绝此订单吗',
    voucherPath: '凭证链接',
    messageInfo: '订单预订信息',
    orderID: '订单ID',
    sonOrderID: '订单号',
    jtrOrderId: '渠道单号',
    orderSource: '订单来源',
    useDate: '指定日期',
    sonProduct: '子产品',
    useDate1: '指定日期',
    useDates: '指定日期',
    travelDate: '游玩日期',
    createTime: '下单时间',
    endTravelDate: '结束时间',
    arrivedTime: '到达时间',
    touristRemarks: '游客备注',
    reserveNum: '预定数量',
    linkMan: '联系人姓名',
    warnning1: '必须真实姓名，用于景区验证',
    linkPhone: '联系人电话',
    linkEmail: '联系人邮箱',
    linkAddress: '快递地址',
    linkCode: '邮政编码',
    linkCreditType: '联系人证件类型',
    linkoptionA: '身份证',
    linkoptionB: '护照',
    linkCreditNo: '联系人证件号码',
    customerUseDate: '使用日期',
    customerTravelDate: '游玩日期',
    customerEndTravelDate: '游玩结束日期',
    customerArriveTime: '到达日期',
    customerGetTicType: '取票方式',
    customerGetTicType0: '免费',
    customerGetTicType1: '快递费',
    distributor: '分销商',
    PDFSendingMode: 'PDF电子票发送方式',
    productPrice: '产品价格',
    Purchase: '采购价格',
    distributionPriceToc: 'C端单价',
    distributionPriceSum: 'C端总价',
    productSalePrice: '产品浮动价',
    productMinPrice: '最低价格(显示用)',
    productTcPrice: '产品偏移价格',
    buyNum: '购买数量',
    orderCnt: '成功数量',
    seatName: '场次名称',
    jtrAppendNum: '追加数量',
    primarynum: '原订数量',
    cancelNum: '取消数量',
    totalAmount: '支付总额',
    customerInfo: '顾客信息',
    customerName: '姓名',
    cusEmail: '客户邮箱',
    Email: '邮箱',
    receiveDate: '领取日期',
    returnDate: '归还日期',
    FileImport: '文件导入',
    upload: '上传',
    onlyUpload: '只能上传',
    noMoreThan: '文件，且不超过',
    generateOrder: '生成订单',
    thisOrder: '此订单在',
    hasConsumed: '用户已消费',
    noData: '暂无数据',
    viewName: '景点名称',
    viewLocal: '所在地',
    viewAddress: '景点地址',
    viewPicture: '景点图片',
    viewRemark: '景点备注',
    viewTelephone: '景点电话',
    payOrder: '支付订单',
    jtrpayOrder: 'jtr支付订单',
    jtrAppend: 'jtr追加订单',
    operated: '操作',
    productSource: '产品来源',
    searchType: '请选择搜索类型',
    searchType1: '订单ID',
    searchType2: '产品名称',
    searchType3: '客人姓名',
    searchType4: '',
    searchType5: '客人邮箱',
    searchType6: '渠道单号',
    system1: '本系统',
    system2: '2cycle系统',
    system3: '乐天系统',
    productConfirmType: '确认方式',
    reserve: '预定',
    isOnlinePay: '支付方式',
    startDate: '最早游玩日期',
    maxNum: '最大预定数',
    minNum: '最小预定数',
    startNum: '最低产品预定数量',
    isExpress: '是否支持快递配送',
    yesExpress: '支持',
    noExpress: '不支持',
    expressPrice: '配送费用',
    priceStartDate: '价格开始时间',
    priceEndDate: '价格结束时间',
    priceDate: '价格开始/结束时间',
    soldNum: '销量',
    soldNumSort: '销量',
    ticketCount: '销量',
    sourceType: '来源',
    sourceType1: 'JPH供应商',
    sourceType2: 'JTR供应商',
    sourceType3: 'KLOOK供应商',
    supplySourceType1: 'JPH产品',
    supplySourceType2: 'JTR产品',
    supplySourceType3: 'KLOOK产品',
    supplySourceType4: '2CYCLE产品',
    haveNoReserve: '已售罄',
    upTime: '上线时间',
    productReserve: '产品预定',
    pictureDown: '图片素材下载',
    voideDown: '视频素材下载',
    fileDepot: '文件仓库',
    takeView: '景点',
    productNumber: '产品编码',
    supplier: '供应商',
    operator: '运营商',
    useFate: '使用流程',
    supplement: '使用流程补充',
    supplements: '使用流程补充',
    ticketTypeName: '票种',
    isOnlinepay: '支付方式',
    num: '件',
    nums: '件',
    num01: '件',
    money: '￥',
    serviceLanguage: '服务语言',
    productPeople: '产品人群要求',
    takeTimeDesc: '营业时间说明',
    productUpTime: '产品上架时间段',
    diningTime: '用餐时段',
    diningPeople: '用餐人数',
    useTime: '使用时间',
    trafficMethod: '交通方式',
    moneyContant: '费用包含',
    moneyNotContant: '费用不包含',
    priceOrFloat: '价格/库存',
    diningDescription: '产品详情',
    picture: '图片',
    titles: '标题',
    numberBuy: '数量(份)',
    reserveDescription: '预订说明',
    beforeDay: '提前天数',
    minteBefore: '分之前预定',
    usingDate: '生效时间',
    canBeUseDate: '有效日期',
    canBeUseDate1: '有效日期',
    returnMethod: '退款设置',
    returnDescription: '退款说明',
    reserveNotice: '预订须知',
    importantNote: '重要提示',
    userNote: '使用说明',
    changeMethod: '兑票柜台',
    comnicationPeople: '联络人',
    contionMen: '联络人',
    telphone: '联络方式',
    welcomeData: '接待时间',
    productDescription: '产品描述',
    dangerConcationMen: '紧急联络人',
    productPackageContainDetail: '套餐包含产品详情',
    productPackageDetail: '套餐产品详情',
    productContainDetail: '产品包含详情',
    SIMSize: 'SIM卡大小',
    netCover: '网络覆盖',
    threeGNetCover: '3G网络流量',
    fourGNetCover: '4G高速网络流量',
    parts: '配件',
    SIMProductDetail: 'SIM卡产品详情',
    WIFIProductDetail: 'wifi产品详情',
    tourProductDetail: '一日游/多日游产品详情',
    ticketProductDetail: '门票详情',
    packageProductDetail: '套餐或打包产品详情',
    freeTourDetail: '自由行详情',
    routeDetail: '路线详情',
    advanceDetail: '预售详情',
    toursTime: '行程时长',
    travelStyle: '线路类型',
    trafficStyle: '交通工具',
    startCourtyOrEnd: '出发城市/目的地',
    jtrPeopleNum: '产品包含成人数 ',
    jtrChildrenNum: '产品包含儿童数',
    peopleNum: '成团人数',
    buyMessage: '购物信息',
    tourDetail: '行程详情',
    giveClass: '赠送项目',
    trafficProductDetail: '交通产品详情',
    ybProductDetail: '夜间巴士产品详情',
    // takePomStyle: '1.兑票方式',
    takePomStyle: '',
    longWord: '预定成功，平台会给预留邮箱发送预定成功邮件，请凭收到的验证码或是二维码，至下面可兑换柜台出示领取实体票。',
    // canBeTakePom: '1.可兑换柜台',
    canBeTakePom: '',
    counterLink: '领取柜台',
    orderMessages: '新联络',
    saleTimes: '营业时间',
    telphoneCommicta: '联系电话：',
    jtrOrderVaildType0: '游客选定的游玩日期当天有效',
    jtrOrderVaildType1: '游客预订日期延后',
    jtrOrderVaildType2: '游客预订日期截止到',
    jtrOrderVaildType3: '游客选定日期延后',
    jtrOrderVaildType4: '游客选定日期截止到',
    orderVaildType0: '指定使用日当天有效',
    ordervaildType12: '下单日开始',
    ordervaildType1: '天内有效',
    ordervaildType2: '下单日开始至指定日期',
    ordervaildType3: '有效',
    ordervaildType4: '指定使用日开始',
    ordervaildType5: '指定使用日开始至指定日期',
    ordervaildType55: '指定使用日开始至指定日期',
    ordervaildType6: '指定日期',
    ordervaildType7: '到',
    ordervaildType8: '内有效',
    ordervaildType9: '指定使用日的',
    ordervaildType10: '天前到指定使用日的',
    ordervaildType11: '天后为止有效',
    ordervaildType13: '天内有效',
    ordervaildType14: '有效',
    ordervaildType15: '内有效',
    orderRefundType0: '不可退款',
    orderRefundType1: '消费前随时可退',
    orderRefundType4: '游玩日期',
    orderRefundType5: '天前可以退款',
    orderRefundType3: '您的订单已过期,系统不提供退款服务！',
    orderRefundType7: '您的订单产品属于不可退款类型，无法提供退款服务！',
    orderRefundType6: '此订单您尚未支付，无法退款',
    eleDetail: '电子票产品详情',
    jtrticketDetail: '门票产品详情',
    entityDetail: '实体票产品详情',
    experienceDetail: '体验产品详情',
    detail3: '一日游/多日游产品详情',
    detail4: 'WI-FI产品详情',
    detail5: 'SIM卡产品详情',
    detail6: '美食产品详情',
    detail7: '交通产品详情',
    detail8: '优惠套票产品详情',
    eleDetailPreview: '电子票产品预览',
    entityDetailPreview: '实体票产品预览',
    experienceDetailPreview: '体验产品预览',
    tourPreview: '一日游/多日游产品预览',
    wifiPreview: 'WIFI产品预览',
    simPreview: 'SIM卡产品预览',
    diningPreview: '餐厅产品预览',
    trafficPreview: '交通产品预览',
    packagePreview: '套餐产品预览',
    spread: '张',
    diningDetail: '餐厅详情',
    diningDetailPreview: '餐厅预览',
    orderStatus: '订单状态',
    floatPrice: '浮动价格',
    ifOnLine: '是否在线',
    onLine: '在线',
    isEdit: '待上线',
    offLine: '已下线',
    SalesSituation: '销售情况',
    orderNum: '单',
    copyOperating: '复制',
    graphicEditing: '图文编辑',
    revoke: '撤销审核',
    modify: '编辑',
    jtrModifylanguage: '多语言编辑',
    more: '更多',
    distributionAuthorization: '分销授权',
    specialPrice: '特殊价格',
    specialPriceSet: '分销商特别价格设定',
    productInformation: '产品信息',
    distributionRange: '分销商户范围授权',
    distributionRangeAll: '全部商户可分销',
    distributionRangeYes: '只有指定的商户可分销',
    distributionRangeNo: '除指定的商户以外商户可分销',
    merchantRangeAll: '全部商户',
    merchantRangeYes: '指定商户',
    merchantRangeNo: '指定商户以外',
    specifiedRange: '指定范围',
    account: '账户',
    PDFSendWay: 'PDF发送方式',
    PDFOnLine: '线上',
    PDFOffLine: '线下',
    connectInformation: '联系信息',
    dialogCancel: '取 消',
    dialogSure: '确 定',
    dialogSave: '保存编辑',
    selectProCategory: '请选择添加产品的类型',
    ticketsMessage: '使用二维码电子票在现场换票或直接消费的门票。',
    ticketsMessage2: '使用二维码换取实体票并使用的景点、娱乐设施门票。',
    ticketsMessage3: '使用二维码在现场换票或直接消费的娱乐设施门票。',
    ticketsMessage4: '一日游、多日游、包车游产品',
    ticketsMessage5: 'Wi-Fi租借',
    ticketsMessage6: 'SIM上网卡',
    ticketsMessage7: '用餐位预订，套餐预订',
    ticketsMessage8: '交通票，接送机，包车产品',
    ticketsMessage9: '优惠价格组合套票产品',
    ticketsMessage10: '夜间巴士产品',
    serialNumbers: '编号',
    belongArea: '所在区域',
    connectWay: '联系方式',
    purchasingSituation: '采购情况',
    proStatus: '产品状态',
    ifOnlineStatus: '在线状态',
    today: '可订今日',
    tomorrow: '可订明日',
    oldPassword: '原密码',
    newPassword: '新密码',
    checkPassword: '确认密码',
    limitDay: '其他',
    limitDays: '其他',
    auditCannot: '审核不通过理由：',
    notMust: '不限',
    breakfast: '早餐',
    lunch: '午餐',
    afternoonTea: '下午茶',
    dinner: '晚餐',
    buffet: '自助餐',
    bus: '班车',
    caddie: '球童',
    cart: '高尔夫球具车',
    overnight_accommodation: '住宿一晚',
    play_early: '提前玩',
    play_through: '优先玩',
    play_through_am: '上午优先玩',
    play_through_pm: '下午优先玩',
    nightSnack: '宵夜',
    singleMeal: '单人餐',
    doubleMeal: '双人餐',
    thirdMeal: '3~4人餐',
    fiveMeal: '5~10人餐',
    tenMeal: '10人以上',
    haveMustData: '有具体时间段',
    common: '共',
    species: '种',
    dayBefore: '天前',
    applyToRefund: '(当地时间)前可申请退款',
    updateNotAudited: '编辑审核不通过理由',
    pleaseEnterAudited: '请输入审核不通过理由',
    updateSuccess: '更新成功！',
    updateFliture: '更新失败！',
    submitError: '很遗憾，提交审核错误，请重试',
    letterCounter: '归还柜台',
    car: '汽车',
    tram: '电车',
    cruise: '游轮',
    tourDetailTemp: '行程详细',
    auditingProductNum: '待审核产品数量',
    productNum: '产品数量',
    orderSum: '订单量',
    payBySupplierNum: '成交额',
    balanceNum: '余额',
    productOrderNum: '平台产品数',
    distritorNum: '分销商数量',
    supplierNum: '供应商数量',
    urgentNum: '紧急处理',
    confirmNum: '已确认订单',
    unpassNum: '审核不通过产品',
    beConfirmNum: '待确认订单',
    cancelingNum: '待处理取消订单',
    unPaymentNum: '未支付订单',
    cancelingOrder: '取消中订单',
    becancelOrder: '已取消订单',
    auditingProduct: '待审核产品',
    supplierAuditing: '待审核供应商',
    distributorAuditing: '待审核分销商',
    notice: '通告',
    releaseNotice: '发布公告',
    haveNotNotice: '暂无通告！',
    unRead: '未读',
    readed: '已读',
    unReadNotice: '未读通告',
    noticeDetail: '通告详情',
    messageStart: '本信息从',
    messageMiddle: '起生效。 管理员于',
    messageEnd: '发布本信息',
    country: '国家',
    province: '省份',
    city: '城市',
    area: '地区',
    year: '年',
    month: '月',
    one: '一',
    two: '二',
    three: '三',
    four: '四',
    five: '五',
    six: '六',
    seven: '日',
    buyPrice: '采购价',
    selectSupplier: '选择供应商',
    updloadFiles: '上传文件：',
    pleaseChange: '请选择',
    auditMessageEnter: '预订信息录入',
    auditMessageEnter1: '预订信息录入',
    enterAmount: '数量',
    pleaseEnterProductAmount: '请输入产品数量',
    endSlary: '结算金额(JPY)',
    endTotalAmount: '产品金额总计',
    ridePlace: '乘车位置',
    getOnTheTrain: '上车地点',
    onTrainTime: '上车时间',
    choseUpPlace: '请选择上车地点',
    choseDownPlace: '请选择下车地点',
    getDownTheTrain: '下车地点',
    downTrainTime: '下车时间',
    orderMessageByMe: '订单信息',
    confirmEmail: '确认单接收邮箱',
    aboutTipMessage: '需要接收订单确认详细，务必正确。',
    aboutOrderLanguageType: '确认订单使用语言',
    aboutChangeData: '选择日期',
    travler: '游客',
    mainTravler: '乘车人代表',
    travlerName: '游客姓名',
    travlerPhone: '游客手机',
    customerEmail: '邮箱',
    customerWechat: '微信',
    customerPassport: '护照',
    customerSex: '性别',
    orderByMessage: '订单附加信息',
    orderExplain: '订单备注说明',
    productUseData: '使用流程',
    canBeTaken: '可兑换柜台',
    mustBeComplate: '必须填写全名，在验证时候需要。',
    productCanBeReciveTo: '此产品需要给客人发送短信或邮件，手机号或者邮件必填一个(非中国大陆手机请填写邮件地址)。',
    submitOrder: '提交订单',
    nowPages: '当前产品',
    travlerEmail: '游客邮箱',
    travlerWebchat: '游客微信',
    travlerPassport: '游客护照',
    travlerAddress: '邮寄地址',
    travlerPostCode: '邮政编码',
    travlerCreditType: '证件类型',
    travlerCreditNo: '证件号码',
    travlerSex: '游客性别',
    mustToWrite: '必填',
    notMustToWrite: '非必填',
    orderStatus0: '生成订单',
    orderStatus1: '提交订单',
    orderStatus2: '取消订单（分销商）',
    orderStatus3: '取消订单（供应商）',
    orderStatus4: '确认订单',
    orderStatus5: '完成订单',
    orderStatus6: '未支付取消订单',
    orderStatus7: '拒绝订单',
    orderStatus8: '确认取消订单',
    orderStatus9: '拒绝取消订单',
    orderStatus10: '自动确认订单',
    orderStatus11: '自动完成订单',
    orderStatus12: '自动取消订单',
    orderStatus13: '支付超时自动取消订单',
    orderStatus14: '申请退款',
    orderStatus15: '确认退款',
    orderStatus16: '拒绝退款',
    orderStatus17: '订单已核销',
    orderStatus18: '订单已出票',
    orderStatus19: '运营商特殊取消',
    orderStatus20: '快速票单方取消',
    orderStatus21: '自动处理过期订单',
    orderStatus22: '合作商接口取消',
    orderStatus23: '系统内单方取消',
    notPaymentTag: '未支付取消',
    travelsSelectData: '订单有效期截止日前',
    jtrOrderRefund0: '游玩日期前',
    jtrOrderRefund1: '游玩日期后',
    jtrOrderRefund2: '天可以退款',
    jtrOrderRefund3: '当日可退',
    jtrOrderRefund4: '天可以退款',
    day: '天',
    ticketPrice: '',
    refundPayment: '退款手续费 :',
    cancelCannot: '取消理由',
    refundCannot: '退款理由',
    cancelOrRefund: '拒绝理由',
    cancelReason: '取消理由',
    admin: '管理员',
    clerk: '业务员',
    refuseCannot: '拒绝理由',
    updateTime: '更新时间',
    counterDetails: '柜台',
    applyDate: '申请日时',
    pleaseIntoCancelReason: '请输入拒绝理由',
    pleaseIntoCancelCannot: '请输入取消理由',
    pleaseIntoInfo: '请输入文字',
    applyType: {
      applyType0: '分销商',
      applyType1: '供应商',
      applyType2: '管理员',
      applyType3: '业务员',
      applyType4: '其他'
    },
    adminAccount: {
      createUser: '添加角色',
      roleName: '角色名',
      createRoleName: '角色名',
      account: '所属账号',
      applyType: '适用类型',
      isEnable: '是否启用',
      enable: '启用',
      disable: '禁用',
      roleDistribution: '权限',
      roleManager: '添加角色',
      authMenu: '权限菜单',
      checkAll: '全选'
    }
  },
  viewMessage: {
    message1: '是否确定保存?',
    message2: '请输入景点名称',
    message3: '请输入景点地址',
    message4: '推荐使用',
    message5: '是否确定保存?',
    message6: '是否确定保存?',
    message7: '是否确定保存?',
    message8: '请选择景点所在地',
    message9: '长度在 3 到 50 个字符',
    sysError: '系统错误！',
    revokeMessage: '此操作将撤销审核, 是否继续?',
    revokeSuccess: '已撤销审核！',
    revokeHavePassed: '该产品审核已经通过不能撤销！',
    revokeHaveNotPassed: '该产品审核没有通过,无法进行撤销操作,请重新提交申请！',
    revokeOperationCanceled: '撤销审核已取消！',
    offLineMessage: '此操作将下线产品, 是否继续?',
    offLineSuccess: '已下线成功！',
    offLineOperationCanceled: '下线操作已取消',
    deleteMessage: '此操作将永久删除该产品, 是否继续?',
    deleteMessageOrder: '此操作将永久删除该订单, 是否继续?',
    deleteSuccess: '删除成功！',
    deleteOperationCanceled: '已取消删除！',
    thisRangeNotEmpty: '该指定范围内商户不能为空！',
    thisPriceRangeNotEmpty: '商户分销价授权不能为空！',
    thisPriceRangeNotNum: '请输入数字！',
    editSuccess: '编辑成功！',
    pleaseDeletePackageProduct: '请先删除打包产品,或在打包产品中移除该产品！',
    upToLine: '此操作后,产品将上线,是否继续?',
    newToUse1: '此操作后,产品将更改批次状态为关闭,是否继续?',
    newToUse0: '此操作后,产品将更改批次状态为正常,是否继续?',
    fileToDelete: '此操作后,此文件库将被永久删除,是否继续?',
    useSuccess: '操作成功',
    useFail: '操作取消',
    holdSuccess: '保存成功！',
    holdError: '保存失败！',
    maxDay: '一次最多设置10年数据',
    submitSuccess: '提交成功！',
    submitSuccessconfirmed: '提交成功！等待确认！',
    submitError: '提交失败！',
    balanceNotDone: '您的账户余额不足,请充值后完成本次订单',
    balanceDone: '恭喜您,支付成功',
    cancelDone: '您的取消申请已发送，请等候商户处理',
    cancelDone2: '已取消成功并退款！请刷新页面确认',
    cancelDone3: '您的退款申请已发送，请等候商户处理',
    cancelError: '商户余额不足，订单暂时无法取消',
    cancelError1: '系统异常，请联络管理员',
    message10: '是否保存编辑？',
    lable1: '取消',
    lable2: '不保存',
    lable3: '保存',
    message11: '长度在 3 到 50 个字符',
    message12: '请选择国家',
    message13: '请选择地区',
    message14: '长度在 3 到 50 个字符',
    message15: '基本信息未填完整',
    message16: '是否放弃编辑？',
    message17: '景点正在使用中，不能删除！',
    confirmDone: '确认成功',
    tipMessage1: '请输入角色备注',
    tipMessage2: '输入长度不超过255位',
    tipMessage3: '请输入角色名称',
    tipMessage4: '输入长度不超过100位',
    tipMessage5: '分佣比例只能为0-100的正整数',
    messageNotCompleteIn: '必要信息未输入完整',
    orderStatusHadUpdate: '订单状态已更新',
    orderRefundFalse: '订单退款申请失败',
    message18: '长度在 0 到 500 个字符',
    message19: '长度在 3 到 500 个字符',
    message20: '当前种类在该时间段内已存在',
    cleckOrder: '确认核销订单',
    cleckOrderCanceled: '取消核销',
    cleckSucc: '核销成功'
  },
  counterMessage: {
    counterName: '柜台名称',
    counterAddress: '柜台地址',
    counterTelephone: '柜台电话',
    busineTime: '营业时间',
    counterPic: '柜台图片',
    lable1: '取消',
    lable2: '不保存',
    lable3: '保存',
    message1: '请输入柜台名称',
    message2: '此操作将永久删除该柜台, 是否继续?',
    message3: '删除成功',
    message4: '正在使用，无法删除',
    message5: '上传柜台图片',
    message6: '是否保存编辑？',
    message7: '请输入柜台名称',
    message8: '请输入柜台地址',
    message9: '请输入柜台电话',
    message10: '请输入正确的柜台电话',
    message11: '长度在 6 到 500 个字符',
    message12: '请输入柜台接待时间',
    message13: '保存失败',
    message14: '保存成功',
    message15: '是否放弃编辑？',
    message16: '长度在 1 到 500 个字符'
  },
  liaisonMessage: {
    liaisonName: '姓名',
    liaisonTelephone: '联络方式',
    receptionTime: '接待时间',
    message1: '请输入联络人姓名',
    message2: '请输入联络人电话',
    message3: '请输入联络人接待时间',
    message4: '确定删除此联络人?',
    message5: '删除成功',
    message6: '正在使用，无法删除',
    message7: '是否保存编辑？',
    message8: '取 消',
    message9: '不保存',
    message10: '保 存',
    message11: '保存失败',
    message12: '是否放弃编辑？',
    message13: '保存失败',
    message14: '保存成功'
  },
  registerMessage: {
    directorWechatComment: '推荐您使用微信，便于敝公司与您沟通。详情请参照另行发放的操作手册。',
    supplierRegister: '供应商注册',
    distributorRegister: '分销商注册',
    accountInfo: '账号信息',
    companyInfo: '公司信息',
    mainBusiness: '主营业务（根据勾选的主营业务，我们会针对性的推荐最适合的产品）',
    mainBusiness1: '主营业务',
    saleType: '销售方式',
    trafficCardTicket: '交通卡券',
    carFree: '包车',
    admissionToThePark: '乐园景点门票',
    foodAndBeverage: '餐饮美食',
    oneDayTour: '一日游',
    daysTour: '多日游',
    characteristicExperience: '特色体验',
    hotel: '酒店',
    physicalShop: '实体店铺',
    fzShop: '飞猪店铺',
    mfwShop: '马蜂窝店铺',
    tbShop: '淘宝店铺',
    xcShop: '携程店铺',
    tcShop: '同程店铺',
    qneShop: '去哪儿店铺',
    tnShop: '途牛店铺',
    cupang: 'cupang',
    gmarket: 'gmarket',
    entry: '请输入',
    directorInfo: '业务负责人信息',
    account: '登录账号',
    password: '输入密码',
    passwordConfirm: '确认密码',
    address: '所在地',
    companyName: '公司名称',
    logo: '公司Logo',
    legalRepresentative: '法定代表人',
    companyAddress: '公司地址',
    companyTelephone: '公司电话',
    companyEmail: '公司邮箱',
    companyWebsite: '官网/店铺链接',
    bankCardNumber: '银行账户',
    qualification: '资质证明',
    directorName: '姓名',
    directorTelephone: '联系手机',
    directorPosition: '职位',
    directorWechat: '微信号',
    directorEmail: '邮箱',
    directorCard: '名片',
    phAccount: '请输入登陆账户',
    phPassword: '请输入登录密码',
    phPasswordConfirm: '请确认登录密码',
    phCompanyName: '请输入公司正式注册名称',
    phLogo: '上传公司Logo',
    phLegalRepresentative: '请输入公司法定代表人',
    phCompanyAddress: '请输入公司详细地址',
    phCompanyTelephone: '请输入公司电话',
    phCompanyEmail: '请输入公司邮箱地址',
    phCompanyWebsite: '请输入公司官网(或其他平台店铺链接)',
    phBankCardNumber: '请输入公司银行账户',
    phQualification: '扫描公司正式注册相关资质证明',
    phDirectorName: '请输入业务负责人姓名',
    phDirectorTelephone: '请输入业务负责人手机号码',
    phDirectorPosition: '请输入业务负责人职位',
    phDirectorWechat: '请输入业务负责人微信号',
    phDirectorEmail: '请输入业务负责人邮箱',
    phDirectorCard: '上传业务负责人名片',
    submitResigt: '提交申请',
    message1: '请输入6-16位大小写英文字母或数字',
    message2: '请确保所填写的账号信息准确无误！',
    message3: '请输入密码',
    message4: '请输入正确的密码',
    message5: '长度在 6 到 16个字符',
    message6: '请再次输入密码',
    message7: '两次输入密码不一致！',
    message8: '请输入正确的密码',
    message9: '请选择国家',
    message10: '请输入公司正式注册名',
    message11: '长度在 6 到 200 个字符',
    message12: '请上传公司Logo',
    message13: '请输入公司法定代表人',
    message14: '长度在 2 到 200 个字符',
    message15: '请输入公司详细地址',
    message16: '长度在 10 到 200 个字符',
    message17: '请输入公司电话',
    message18: '请输入正确的电话',
    message19: '长度在 6 到 20 个字符',
    message20: '请输入公司邮箱地址',
    message21: '请输入正确的邮箱地址',
    message22: '长度在 7 到 50 个字符',
    message23: '请输入公司官网',
    message24: '长度在 4 到 300 个字符',
    message25: '请输入公司银行账户',
    message26: '请输入正确的银行账户',
    message27: '长度在 10 到 100 个字符',
    message28: '请上传公司正式资质证明',
    message29: '请输入业务负责人姓名',
    message30: '长度在 2 到 50个字符',
    message31: '请输入联系手机',
    message32: '请输入正确的手机号码',
    message33: '长度在 6 到 20 个字符',
    message34: '请输入职位',
    message35: '长度在 2 到 50 个字符',
    message36: '请输入微信号',
    message37: '长度在 6 到 50 个字符',
    message38: '请输入业务负责人名片',
    message39: '是否提交注册？',
    message40: '注册成功',
    message41: '注册失败',
    message42: '请输入账号',
    message43: '长度在 6 到 30 个字符',
    message44: '用户名已存在',
    message45: '请输入邮箱地址',
    message46: '长度在 5 到 50 个字符',
    message47: '请输入正确的邮箱',
    message48: '邮箱已注册',
    message49: '是否放弃注册？',
    message50: '主营业务至少勾选一个，可多选',
    message51: '销售方式至少勾选一个，可多选',
    message52: '选择其他选项时,该信息必填',
    message53: '输入的最大长度为20'
  },
  menu: {
    sysHome: '系统首页',
    product: '产品管理',
    productList: '我的产品',
    releaseProducts: '发布产品',
    releaseThirdProducts: '发布第三方产品',
    supplyManageProduct: '产品售卖管理',
    importThirdSystemProduct: '产品导入管理',
    conciseDining: '发布餐厅产品',
    conciseSetMeal: '新增打包产品',
    conciseExperience: '发布体验产品',
    productAuditing: '产品审核',
    addBusFlag: '发布夜间巴士产品',
    orderManagement: '订单管理',
    orderManagementC: 'C端管理',
    operatorOrderManagement: '订单管理',
    operatorOrderMagnToC: 'ToC订单管理',
    operatorOrderManagement_chargeback: '订单退单权限',
    reserve: '产品预定',
    distriOrderMagn: '订单管理',
    disTocOrderManagement: 'ToC订单管理',
    bulkPurchaseList: '批量采购管理',
    tocDistributorManageProduct: 'ToC产品售卖管理',
    distriOrderMagnToC: 'ToC订单管理',
    applyDistribution: 'ToC分销审核',
    revenueManagement: 'ToC分销管理',
    revenueDetail: 'ToC收益管理',
    applyCash: 'ToC提现管理',
    operatApplyCash: 'ToC提现管理',
    coupon: 'ToC优惠券管理',
    pinTicketMagn: '验证销票管理',
    ticket: '实体票在库管理',
    ticketDepot: '票仓管理',
    warehouse: '仓库管理',
    userDepot: '用户仓库管理',
    pinTicket: '验证销票',
    pdfTicket: '电子票在库管理',
    pdfFiles: 'PDF文件库管理',
    shopManage: '商户管理',
    distributor: '分销商管理',
    supplier: '供应商管理',
    scenicSpot: '景点管理',
    scenicSpotList: '景点管理',
    finance: '财务统计',
    financeStatement: '财务报表',
    financeDetail: '财务报表详情',
    ActuarialManagement: '精算管理',
    withdrawals: '充值/提现管理',
    operatorWithdrawal: '充值/提现管理',
    trades: '交易明细',
    record: '充值/提现记录',
    withdrawal: '充值/提现',
    recharge: '充值/提现',
    sys: '系统管理',
    merchantInfo: '商户信息',
    clerk: '业务员管理',
    adminAccount: '权限管理',
    operator: '管理员管理',
    exportRules: '导出规则管理',
    noticeManager: '通告管理',
    liaisons: '联络人管理',
    counter: '柜台管理',
    pwdSet: '密码设置',
    newOrderEmail: '订单通知管理',
    ticketDepot_ticketDepotManager: '票仓管理员',
    ticketDepot_stockManager: '库存管理员',
    pdfFiles_stockManager: '库存管理员',
    operatorWithdrawal_operationAuth: '财务操作权限',
    operatorWithdrawal_auditAuth: '财务审核权限',
    auditFlag: '不需要审核',
    loginNotice: '自我游系统功能升级通告（20170621）',
    recover: '还原',
    clear: '清空',
    pageSetting: '首页图片设置',
    productLogList: '产品修改记录'
  },
  login: {
    userLogin: '用户登录',
    rememberLoginStatus: '记住登录状态',
    forgetPassword: '忘记密码？',
    loginIn: '登录',
    register: '注册',
    copyRight: '版权所有 © 2019 东瀛假日',
    recordInformation: '蜀ICP备18029410号-2',
    rrecordInformation2: '特定商取引法',
    message1: '请输入用户名',
    message2: '请输入密码',
    message3: '请输入正确的密码'
  },
  selectMerchantType: {
    imSupplier: '我是供应商',
    imDistributor: '我是分销商',
    selectType: '请选择商户类型'
  },
  notice: {
    noticeModify: '编辑通告',
    noticeAdd: '添加通告',
    noticeTitle: '通告标题：',
    noticeContent: '通告内容',
    noticeTitlePlaceholder: '请输入通告标题',
    validDate: '有效日期：',
    DateSelectRange: '选择日期范围',
    publicationScope: '选择范围：',
    all: '一般',
    distributor: '分销商',
    supplier: '供应商',
    pulicationConfirm: '确认发布',
    tip: '提示',
    saveOrNot: '是否保存？',
    notSave: '不保存',
    save: '保 存',
    message1: '长度在 3 到 150 个字符',
    message2: '请选择有效日期',
    message3: '请选择范围',
    message4: '是否放弃编辑？',
    message5: '基本信息未填完整',
    message6: '保存成功',
    message7: '保存失败',
    message8: '删除失败！',
    message9: '删除成功！',
    message10: '此操作将永久删除该文件, 是否继续?',
    message11: '选择商户不能为空！',
    noticeManage: '通告管理',
    noticePublication: '添加通告',
    noticeTitle1: '通告标题',
    search: '搜索',
    index: '序号',
    title: '标题',
    publicationScope1: '发布范围',
    validDate1: '有效日期'
  },
  exportRules: {
    exportRuleTitle: '导出规则管理',
    newExportRule: '新建导出规则',
    editExportRule: '编辑导出规则',
    lableBusinessType: '商户类型',
    pageType: '页面类型',
    exportRuleName: '导出规则名称',
    exportRuleRemark: '导出规则备注',
    search: '查询',
    ruleName: '规则名称',
    ruleRemark: '规则备注',
    modify: '编辑',
    delete: '删除',
    lable1: '全部',
    lable2: '分销商',
    lable3: '供应商',
    lable4: '产品一览',
    lable5: '订单一览',
    lable6: '运营商',
    lable7: '未知',
    lable8: '导出项设置',
    lable9: '移除',
    lable10: '添加',
    lable11: '所有项目',
    lable12: '导出项',
    lable13: '核销一览',
    message1: '是否确定删除？',
    message2: '删除成功',
    message3: '基础规则，不能删除',
    message4: '规则使用中，不能删除',
    message5: '请输入导出规则名称',
    message6: '请输入导出规则备注',
    message7: '请选择商户类型',
    message8: '请选择页面类型',
    message9: '长度在 3 到 100 个字符',
    message10: '长度在 3 到 500 个字符',
    message11: '是否确定重置？',
    message12: '保存成功',
    message13: '是否放弃编辑？',
    button1: '提交保存',
    button2: '立即创建',
    button3: '重置'
  },
  clerk: {
    clerkTitle: '业务员管理',
    addClerk: '添加业务员',
    editClerk: '编辑业务员',
    account: '账号',
    name: '姓名',
    telphone: '电话',
    emailAddress: '邮箱地址',
    clerkAccount: '业务员账号',
    clerkName: '业务员姓名',
    clerkPwd: '业务员密码',
    confirmPwd: '确认密码',
    clerkTel: '业务员手机号',
    message1: '业务员账号/姓名',
    message2: '请选择权限',
    message3: '是否确定删除？',
    message4: '删除成功',
    message5: '设置成功',
    message6: '请输入业务员账号',
    message7: '账号只能由字母、数字、下划线、分隔符组成，字母开头',
    message8: '请输入业务员姓名',
    message9: '业务员姓名不能为空',
    message10: '请输入业务员密码',
    message11: '请输入6-16位大小写英文字母或数字',
    message12: '必须跟上面输入的一致',
    message13: '请输入业务员手机号',
    message14: '请输入业务员邮件地址',
    message15: '可以通过邮件来接收系统信息',
    message16: '长度在 1 到 50 个字符',
    message17: '请输入正确的密码',
    message18: '长度在 6 到 16 个字符',
    message19: '请输入正确的密码',
    message20: '是否提交保存？',
    message21: '保存成功',
    message22: '请输入账号',
    message23: '长度在 6 到 30 个字符',
    message24: '请输入正确的账号',
    message25: '用户名已存在',
    message26: '请再次输入密码',
    message27: '两次输入的密码不一致！',
    message28: '长度在 5 到 50 个字符',
    message29: '请输入正确的邮箱',
    message30: '邮箱已注册',
    message31: '长度在 6 到 20 个字符',
    message32: '请输入正确的手机号',
    message33: '是否放弃编辑？',
    lable1: '权限',
    lable2: '移除',
    lable3: '添加',
    lable4: '角色列表',
    lable5: '已添加角色'
  },
  merchant: {
    merchantInfo: '商户信息',
    distributorManage: '分销商管理',
    supplierManege: '供应商管理',
    all: '全部',
    waitAudit: '待审核',
    auditPass: '审核通过',
    auditNG: '审核不通过',
    auditNG2: '审核未通过',
    auditNGReason: '编辑审核不通过理由',
    searchContent: '商户名称/ID',
    businessName: '商户名称',
    createDate: '申请时间',
    auditStatus: '状态',
    auditUserName: '审核人',
    lableTodo: '处理',
    lableWatch: '查看',
    lableAuth: '权限',
    lableExpSet: '导出设置',
    accountInfo: '账号信息',
    loginAccount: '登录账号',
    companyName: '公司名称 ',
    companyLogo: '公司logo',
    legalRepresentative: '法定代表人',
    companyAddress: '公司地址',
    companyTelephone: '公司电话',
    companyWebsite: '官网/店铺链接',
    companyEmail: '公司邮箱',
    bankCardNumber: '银行账户',
    qualificationPath: '资质证明',
    location: '所在地',
    baseInfo: '基本信息',
    directorInfo: '业务负责人信息',
    directorName: '姓名',
    directorPosition: '职位',
    directorEmail: '邮箱',
    directorTelephone: '联系手机',
    directorWechat: '微信号',
    directorCardPath: '名片',
    setAuthAuditPass: '设定权限并审核通过',
    selectAuth: '请选择权限',
    message1: '请选择权限',
    message2: '导出设置',
    message3: '导出页面类型',
    message4: '产品导出项目设定',
    message5: '订单导出项目设定',
    message6: '导出规则',
    message7: '请选择导出规则名称',
    message8: '请选择导出页面类型',
    message9: '请选择导出规则',
    message10: '设置成功',
    message11: '(商户在系统的唯一编号，用于识别用户身份)',
    message12: '分销情况汇总',
    message13: '总订单量',
    message14: '总订单金额',
    message15: '总出票量',
    message16: '帐户余额情况',
    message17: '账户余额',
    message18: '查看账户交易日志',
    message19: '充值/提现历史记录',
    message20: '操作成功',
    message21: '操作失败',
    message22: '是否放弃审核？',
    message23: '授信设置',
    message24: '核销导出项目设定',
    lable1: '移除',
    lable2: '添加',
    lable3: '角色列表',
    lable4: '已添加角色',
    yayaPaySet: '销票账户设定',
    easyGoUser: '供应商账户',
    yayaPayUser: '销票账户',
    pleaseEnterYayaPayUser: '请输入销票账户',
    pleaseEnterLessTen: '最多绑定10个账号！',
    lengthMustLess100: '账号长度应该小于或等于100！',
    yayaAccountHadExists: '存在重复销票账户，添加失败',
    yayaAccountExists: '销票账户重复，请重新输入',
    enableSwitch: '启用开关',
    lineOfCredit: '授信额度',
    creditDate: '授信日期'
  },
  merchantInfo: {
    merchantInfo: '商户信息',
    merchantInfoEdit: '商户信息编辑',
    auditNG: '审核未通过',
    accountInfo: '账号信息',
    auditStatus: '审核状态',
    loginAccount: '登录账号',
    location: '所在地',
    baseInfo: '基本信息',
    companyName: '公司名称',
    companyLogo: '公司logo',
    legalRepresentative: '法定代表人',
    companyAddress: '公司地址',
    companyTelephone: '公司电话',
    companyWebsite: '官网/店铺链接',
    companyEmail: '公司邮箱',
    bankCardNumber: '银行账户',
    qualificationPath: '资质证明',
    supplierSummary: '分销情况汇总',
    orderTotal: '总订单量',
    orderTotalPay: '总订单金额',
    ticketTotal: '总出票量',
    accountBalanceInfo: '帐户余额情况',
    accountBalance: '账户余额',
    seeBusinessLog: '查看账户交易日志',
    seeRechargeLog0: '查看充值/提现日志',
    seeRechargeLog1: '查看提现日志',
    directorInfo: '业务负责人信息',
    directorName: '姓名',
    directorPosition: '职位',
    directorEmail: '邮箱',
    directorTelephone: '联系手机',
    directorWechat: '微信号',
    directorCardPath: '名片',
    submitAudit: '提交审核',
    submitEdit: '提交编辑',
    notSave: '不保存',
    save: '保 存',
    message1: '(商户在系统的唯一编号，用于识别用户身份)',
    message2: '请确保所填写的账号信息准确无误！',
    message3: '是否保存编辑？',
    message4: '请选择国家',
    message5: '请输入公司正式注册名',
    message6: '长度在 6 到 200 个字符',
    message7: '请上传公司Logo',
    message8: '请输入公司法定代表人',
    message9: '长度在 2 到 200 个字符',
    message10: '请输入公司详细地址',
    message11: '长度在 10 到 200 个字符',
    message12: '请输入公司电话',
    message13: '请输入正确的电话',
    message14: '长度在 6 到 20 个字符',
    message15: '请输入公司邮箱地址',
    message16: '请输入正确的邮箱地址',
    message17: '长度在 7 到 50 个字符',
    message18: '请输入公司官网',
    message19: '长度在 4 到 50 个字符',
    message20: '请输入公司银行账户',
    message21: '请输入正确的银行账户',
    message22: '长度在 10 到 100 个字符',
    message23: '请上传公司正式资质证明',
    message24: '请输入业务负责人姓名',
    message25: '长度在 2 到 50个字符',
    message26: '请输入联系手机',
    message27: '请输入正确的手机号码',
    message28: '请输入职位',
    message29: '请输入微信号',
    message30: '长度在 6 到 50 个字符',
    message31: '请输入业务负责人名片',
    message32: '是否提交更改？',
    message33: '编辑成功',
    message34: '编辑失败',
    message35: '请输入邮箱地址',
    message36: '长度在 5 到 50 个字符',
    message37: '请输入正确的邮箱',
    message38: '邮箱已注册'
  },
  errorMsg: {
    user: {
      noAuth: '用户权限不足,请联系管理员',
      systemMsg: '系统错误',
      noUserOrPassword: '账号不存在或密码错误',
      setUsernameOrPassword: '请输入账号或密码'
    }
  },
  operator: {
    jtrOrderReimburse: '系统内单方取消',
    operatorManege: '管理员管理',
    addOperator: '添加管理员',
    updateOperator: '编辑管理员',
    updatePwd: '密码编辑',
    updateInfo: '信息编辑',
    auth: '权限',
    searchText: '管理员账号/姓名',
    account: '账号',
    name: '姓名',
    opearate: '操作',
    opeAccount: '管理员账号',
    opeName: '管理员姓名',
    opePwd: '管理员密码',
    opeNewPwd: '管理员新密码',
    checkPwd: '确认密码',
    lable1: '移除',
    lable2: '添加',
    lable3: '角色列表',
    lable4: '已添加角色',
    message1: '请选择权限',
    message2: '是否确定删除？',
    message3: '删除成功',
    message4: '设置成功',
    message5: '请输入管理员账号',
    message6: '账号只能由字母、数字、下划线、分割符组成，首位字母',
    message7: '请输入管理员姓名',
    message8: '管理员姓名不能为空',
    message9: '请输入管理员密码',
    message10: '请输入6-16位大小写英文字母或数字',
    message11: '必须跟上面输入的一致',
    message12: '长度在 1 到 50 个字符',
    message13: '长度在 6 到 16 个字符',
    message14: '请输入正确的密码',
    message15: '是否提交保存？',
    message16: '保存成功',
    message17: '请输入账号',
    message18: '长度在 6 到 30 个字符',
    message19: '请输入正确的账号',
    message20: '用户名已存在',
    message21: '请再次输入密码',
    message22: '两次输入的密码不一致！',
    message23: '是否放弃编辑？'
  },
  product: {
    rule_0_500: '长度在 0 到 500 个字符',
    rule_0_5000: '长度在 0 到 5000 个字符',
    rule_1_200: '长度在 1 到 200 个字符',
    rule_1_2000: '长度在 1 到 2000 个字符',
    rule_1_500: '长度在 1 到 500 个字符',
    rule_0_200: '长度在 0 到 200 个字符',
    rule_0_2000: '长度在 0 到 2000 个字符',
    rule_0_50: '长度在 0 到 50 个字符',
    rule_0_1_500: '长度在 0 到 500 个字符',
    rule_1_50: '长度在 1 到 50 个字符',
    rule_0_20: '长度在 0 到 20 个字符',
    rule_n1_2: '长度在 1 到 2 位数字',
    rule_n1_4: '长度在 1 到 4 位数字',
    rule_n1_6: '长度在 1 到 6 位数字',
    rule_n0_2: '长度在 0 到 2 位数字',
    rule_n0_5: '长度在 0 到 5 位数字',
    rule_n0_6: '长度在 0 到 6 位数字',
    rule_mail: '请输入邮件内容',
    integer_1: '请输入整数值',
    integer_2: '请输入正整数值',
    selDate: '选择日期',
    back: '返回',
    ticketType_1: 'PDF电子票在库',
    ticketType_3: '有PDF电子票非在库',
    ticketType_4: '无PDF电子票',
    choose_sys: '选择系统：',
    chooseDepot: '选择仓库',
    baseInfo: '基本信息',
    content: '产品内容',
    priceSet: '价格设定',
    reserveSet: '预定设置',
    saveDraft: '保存到草稿箱',
    preview: '预览',
    submitCheck: '提交审核',
    submitAuditAndPass: '提交审核并通过',
    isExitProduct: '是否退出产品录入',
    isSaveDraft: '是否保存草稿？',
    noSave: '不保存',
    save: '保存',
    add: '添加',
    edit: '编辑',
    product_0: '产品 (电子票)',
    product_1: '产品 (实体票)',
    product_2: '产品 (体验)',
    product_3: '产品 (一日游/多日游)',
    product_4: '产品 (WIFI)',
    product_5: '产品 (SIM卡)',
    product_6: '产品 (餐厅)',
    product_7: '产品 (交通)',
    product_8: '产品 (套餐)',
    doNotSave: '内容没有更新，无须重复保存',
    reqMsg_1: '恭喜，已提交审核',
    reqMsg_2: '恭喜，保存成功',
    reqMsg_3: '很遗憾，提交审核失败！',
    reqMsg_4: '很遗憾，保存失败！',
    reqMsg_5: '很遗憾，提交审核错误，请重试',
    reqMsg_6: '很遗憾，保存错误，请重试',
    reqMsg_7: '该套餐未添加子产品！',
    reqMsg_8: '恭喜，已审核通过',
    reqMsg_9: '很遗憾，审核失败！',
    reqMsg_10: '很遗憾，审核错误，请重试！',
    reqMsg_11: '很遗憾，导入产品错误，请重试！',
    reqMsg_12: '该产品编号已被绑定，请重新输入！',
    reqMsg_13: '该产品暂无价格库存，无法导入！',
    fileDepot_no: '请选择文件仓库',
    baseInfo_no: '基本信息未填完整',
    content_no: '产品内容未填完整',
    reserveSet_no: '预定设置未填完整',
    explain01: '名称构成:地名+产品名称+数量+另一产品名称+数量+特色，例如“北京顺景温泉(含鱼疗)2张+南山滑雪(电子票)2张”',
    explain02: '产品标题下方的关键字等',
    explain03: '分销商不可见，方便供应商搜索产品',
    explain04: '大人（18周岁以上），学生（12~17周岁），小孩，幼儿，情侣',
    productName01: '套餐名称：',
    productName02: '产品名称：',
    qrCodeName: '二维码名称',
    productName_placeholder: '请输入产品名称',
    qrCodeName_placeholder: '请输入二维码名称',
    productPrice_placeholder: '请输入产品偏移价格',
    productMin_Price_placeholder: '请输入产品最低价格',
    errorProductConfirmType1: '子产品包含二次确认产品，订单确认方式只可以选择人工确认',
    errorProductConfirmType2: '子产品不包含二次确认产品，订单确认方式只可以选择自动确认',
    errorProductConfirmType3: '当前产品为优惠套票子产品，暂时无法修改订单确认类型',
    orderNum_placeholder: '请输入排序',
    productHighlights01: '套餐亮点：',
    productHighlights02: '产品亮点：',
    productHighlights_placeholder: '请输入产品亮点',
    productInsideRemark: '内部备注：',
    productInsideRemark_placeholder: '请输入内部备注',
    scenicSpot: '对应景点：',
    ticketType: '票种：',
    ticketType_placeholder: '请输入票种',
    productSaleDate: '上架时间段：',
    productSaleDate_placeholder: '请选择上架时间段',
    chooseDepot_rule: '请选择仓库',
    productName_rule: '请输入产品名称',
    scenicSpotArr_rule: '请至少选择一个景点',
    scheduleDuration: '行程时长：',
    scheduleDuration_placeholder: '请输入行程时长',
    imageExplain: '图片描述：',
    uploadBtn: '点击上传',
    videoExplain: '视频资料：',
    productPackageDetail: '套餐产品详情：',
    mealTimeInterval: '用餐时段：',
    mealTime_1: '不限',
    mealTime_2: '早餐',
    mealTime_3: '午餐',
    mealTime_4: '下午茶',
    mealTime_5: '晚餐',
    mealTime_6: '夜宵',
    mealNumber: '用餐人数：',
    mealNumber_1: '单人餐',
    mealNumber_2: '双人餐',
    mealNumber_3: '3~4人餐',
    mealNumber_4: '5~10人餐',
    mealNumber_5: '10人以上',
    mealDetail01: '组名：',
    mealDetail01_placeholder: '请输入套餐组名',
    mealDetail02: '内容：',
    mealDetail03: '序号',
    mealDetail04: '名称',
    mealDetail05: '数量',
    mealDetail06: '照片',
    mealDetail07: '操作',
    mealDetail07_del: '删除',
    mealDetail07_up: '上移',
    mealDetail07_down: '下移',
    up_msg: '已经是最顶行了',
    down_msg: '已到最尾部了',
    mealDetail07_add: '添加一行',
    md_delGroup: '删除组',
    md_addGroup: '添加组',
    md_validMsg: '套餐详情数据不完整',
    md_addMsg: '最多添加20行！',
    md_addMsg1: '最多添加10组！',
    useTime: '使用时间：',
    useTime_1: '不限',
    useTime_2: '有具体时间段',
    editorProductDetail: '详细文字描述：',
    viewAddress: '地址：',
    viewAddress_placeholder: '请输入景点地址',
    businessTime: '营业时间：',
    businessTime_placeholder: '请输入营业时间',
    productPeople_placeholder: '请输入产品人群要求',
    exclusive: '车辆专用标识：',
    exclusive_1: '无',
    exclusive_2: '男性专用车辆',
    exclusive_3: '女性专用车辆',
    lang: '服务语言：',
    lang_1: '中文',
    lang_2: '英文',
    lang_3: '日文',
    lang_4: '韩文',
    productTraffic: '交通方式：',
    productTraffic_placeholder: '请输入交通方式',
    networkFlow4g: '4G高速网络流量：',
    networkFlow4g_placeholder: '请输入4G高速网络流量',
    networkFlow3g: '3G网络流量：',
    networkFlow3g_placeholder: '请输入3G网络流量',
    networkCoverage: '网络覆盖：',
    networkCoverage_placeholder: '请输入网络覆盖',
    wifiAccessories: '配件：',
    wifiAccessories_placeholder: '请输入配件',
    simSize: 'SIM卡大小：',
    simSize_placeholder: '请输入SIM卡大小',
    pathType: '线路类型：',
    pathType_1: '拼车游',
    pathType_2: '包车游',
    pathType_3: '接送机',
    traffic: '交通工具：',
    traffic_1: '汽车',
    traffic_2: '电车',
    traffic_3: '游轮',
    groupNumber: '成团人数：',
    groupNumber_placeholder: '请输入成团人数',
    shoppingType: '购物信息：',
    shoppingType_1: '不含购物',
    shoppingType_2: '含购物',
    scheduleInfo: '具体行程：',
    productCostInclude: '费用包含：',
    productCostInclude_placeholder: '请输入费用包含内容',
    productCostExclusive: '费用不含：',
    productCostExclusive_placeholder: '请输入费用不包含内容',
    productUseFlow: '使用流程：',
    productUseFlow_placeholder: '请输入使用流程',
    productSupplementPath: '使用流程补充',
    userNote: '使用说明：',
    userNote_placeholder: '请输入使用说明',
    importantNote: '重要提示：',
    importantNote_placeholder: '请输入重要提示',
    editorFreeItem: '赠送项目：',
    newProductPackageDtoList_rule: '请至少写一个套餐详情',
    scheduleInfoDtoList_rule: '最少有一个行程',
    reserveLimitDay: '预定时间限制：',
    rld01: '使用日期的',
    rld02: '天前的',
    rld03_placeholder: '时间点',
    rld04: '之前预定（日本时间）',
    confirmHour: '订单确认方式：',
    confirmHour_1: '自动确认',
    confirmHour_2: '人工确认',
    ch01: '二次确认处理时间：',
    ch02: '日本营业日工作小时',
    ch03: '小时（自然时长）',
    maxReserveNummber: '最大预定数：',
    minReserveNummber: '最小预定数：',
    mrn_explain: '\'0\'表示不限制数据',
    orderValid: '订单有效期设置：',
    ov01: '指定使用日当天有效',
    ov02: '下单日开始',
    ov03: '下单日开始至指定日期',
    ov04: '指定使用日开始',
    ov05: '指定使用日开始至指定日期',
    ov06: '指定日期',
    ov07: '指定使用日的',
    orderRefund: '订单退改：',
    orderRefund_1: '不可退改',
    orderRefund_2: '订单有效期截止日前可申请退款',
    orderRefund_3: '消费前随时可退',
    refundDescription: '退款说明：',
    rdi_placeholder: '请输入退款说明',
    customerData: '预订填写要求：',
    customerData_1: '要求输入每个客人资料',
    customerData_2: '只需要输入一个客人资料',
    mustFillInInf: '客人必填信息：',
    mustFillInInf_1: '姓名',
    mustFillInInf_2: '手机',
    mustFillInInf_3: '微信号',
    mustFillInInf_4: '护照',
    mustFillInInf_5: '性别',
    mustFillInInf_6: '使用日期',
    mustFillInInf_7: '领取日期',
    mustFillInInf_8: '乘车人姓氏',
    mustFillInInf_9: '乘车人名字',
    mustFillInInf_10: '乘车人电话',
    mustFillInInf_11: '乘车人邮箱',
    mustFillInInf_12: '乘车人性别',
    mustFillInInf_13: '乘车人年龄',
    mustFillInInf_14: '紧急联系电话',
    mustFillInInf_15: '乘车人类别',
    mustFillInInf_16: '同行者',
    customItem: '自定义客人输入项',
    ci01: '输入项目名称',
    ci01_placeholder: '项目名称',
    ci02: '是否为空',
    ci02_placeholder: '请选择',
    ci02_1: '可以为空',
    ci02_2: '不可为空',
    ci03: '说明(在下单界面的输入框下部显示)',
    ci03_placeholder: '说明',
    ci04: '操作',
    ci04_del: '删除',
    ci05: '增加自定义项',
    editorNotice: '预定须知：',
    orderLiaison: '订单联络：',
    emergencyLiaison: '紧急联络：',
    validateAuthority: '核销权限：',
    receiveCounter01: '领取柜台：',
    receiveCounter02: '实体票领取柜台：',
    returnCounter: '归还柜台：',
    reserveLimitDay_rule: '请输入预定时间限制',
    reserveLimitDay_rule1: '1到99天之内',
    reserveLimitDay_rule2: '请输入时间点',
    orderDayNotMore: '下单日开始天数不能大于2位数',
    trip01: '第',
    trip02: '天',
    trip03: '行程: ',
    trip04: '添加新行程',
    trip05: '添加一天',
    trip06: '时间段：',
    trip06_placeholder: '选择时间范围',
    trip07: '去哪儿：',
    trip07_placeholder: '什么时间去哪儿？',
    trip08: '行程内容：',
    trip08_placeholder: '例如：第几天去哪里？怎么去？有什么特色？',
    trip09: '行程图片：',
    trip09_btn: '点击上传',
    trip10: '保存行程',
    trip_msg1: '未选择行程',
    trip_msg2: '天，行程',
    tripRange_rule: '请输入时间段',
    groupContentTitle_rule: '请输入去哪儿',
    groupContent_rule: '请输入行程内容',
    imageList_rule: '请设置行程图片',
    trip_msg3: '请先选择一个行程,然后保存行程！',
    trip_msg4: '恭喜，保存成功',
    price01: '库存和价格',
    price02: '时间段-',
    price03: '新增时间段',
    price04: '删   除',
    price05: '时间段',
    price06: '选择时间范围',
    price061: '时间段不能重合',
    price07: '采购价',
    price08: '请输入采购价',
    price09: '分销价',
    price10: '请输入分销价',
    price11: '市场价',
    price12: '请输入市场价',
    price13: '库存量',
    price14: '请输入库存量',
    price15: '件',
    price16: '保   存',
    price17: '重   置',
    price18: '日期范围不能为空',
    price19: '时间段不能为空',
    price20: '日期范围',
    price21: '円',
    price22: '分销平台采购价',
    price23: '请输入分销平台采购价',
    price24: '零售价',
    price25: '请输入零售价',
    price26: '新增种类',
    price27: '种类名称',
    price28: '请输入种类名称',
    price29: '价格种类-',
    price30: '请选择价格种类',
    price31: '请输入价格种类的总库存',
    price32: '总库存应大于使用数',
    price33: '总库存应大于0',
    price34: '请输入指定的价格种类(日本語)：大人、小児、身障者大人、 身障者小児',
    price_msg1: '请先选择日期',
    price_msg2: '时间段-',
    price_msg3: '未保存',
    price_msg4: '请先选择日期和价格种类',
    price_msg5: '保存成功',
    price_msg6: '保存失败',
    price_msg7: '删除成功',
    price_msg8: '删除失败',
    price_msg9: '最多添加50条数据',
    price_msg10: '选中项不能为空',
    price_msg11: '确定将覆盖该时间段的所有已存在数据，是否确认保存？',
    price_msg12: '确定将删除时间段“',
    price_msg13: '”的所有数据，是否确认删除？',
    price_msg14: '将覆盖该价格种类所有已存在数据,请确认是否保存?',
    price_msg15: '确定将删除该价格种类所有数据,请确认是否删除?',
    price_msg16: '该价格种类正在被使用,无法删除',
    price_msg17: '该产品已存在相同的价格种类,保存失败',
    refund01: '订单有效期截止日前',
    refund02: '天，退款手续费：',
    refund03: '移除',
    refund04: '自定义追加',
    refund05: '退款手续费：',
    counter01: '选择柜台',
    counter02: '柜台',
    counter03: '地址',
    counter04: '电话',
    counter05: '营业时间',
    liaison01: '选择联络人',
    clerk01: '选择业务员',
    clerk02: '账号',
    clerk03: '业务员',
    clerk04: '联系电话',
    clerk05: '邮箱',
    liaison02: '联络人',
    liaison03: '联络方式',
    liaison04: '接待时间',
    spot01: '选择对应景点',
    spot02: '选择景点',
    spot03: '取 消',
    spot04: '确 定',
    takeP01: '从产品库中选择产品',
    takeP02: '至少有一个子产品才能保存或提交套餐',
    takeP03: '序号',
    takeP04: '标题',
    takeP05: '采购价',
    takeP06: '分销价',
    takeP07: '市场价',
    takeP08: '数量',
    takeP09: '操作',
    takeP10: '引用数据',
    takeP11: '从产品库中选择产品',
    takeP12: '删除',
    takeP13: '价格种类',
    takeP14: '车辆专用标识',
    stockNumber01: '库存数',
    stockNumber02: '使用数',
    stockNumber03: '禁用',
    stockNumber04: '启用',
    priceTypeHistory01: '查看履历',
    priceTypeHistory02: '库存增加',
    priceTypeHistory03: '库存减少',
    upload01: '只能上传jpg/png/jpeg/gif文件，且不超过2MB',
    upload02: '最大上传20MB视频',
    upload03: '最多上传',
    upload04: '张图片！',
    upload05: '个视频！',
    upload06: '该文件非有效图片格式！',
    upload07: '上传图片大小不能超过 2MB！',
    upload08: '文件名不能有逗号！',
    upload09: '该文件非有效视频格式！',
    upload10: '上传视频大小不能超过 20MB！',
    upload11: '上传失败！',
    upload12: '上传错误！',
    upload13: '请提供实体票·柜台·接待设施外观的照片',
    upload14: '个文件',
    upload15: '上传文件大小不能超过 5MB！',
    calendar01: '年',
    calendar02: '月',
    calendar03: '全选当月库存',
    calendar04: '件',
    clerkTable01: '默认所有业务员均可核销',
    week_1: '一',
    week_2: '二',
    week_3: '三',
    week_4: '四',
    week_5: '五',
    week_6: '六',
    week_7: '日',
    explain_1: '采购价：售卖给平台的价格（平台的进价），供应商定期向平台请款的单价',
    explain_2: '分销价：平台售卖给旅行社（分销商）的价格',
    explain_3: '分销价和采购价的差额是平台的利润',
    explain_4: '说明："0"代表无库存',
    explain_5: '分销平台采购价：EASYGO系统售卖给其他分销平台的价格，与采购价的差额是平台的利润。',
    explain_6: '市场价：一般市场参考售价',
    explain_7: '零售价：建议分销商设定的BtoC售价',
    explain_8: '价格种类(日本語)填写说明：',
    explain_9: '价格(大人)',
    explain_10: '价格(小児)',
    explain_11: '价格(身障者大人)',
    explain_12: '价格(身障者小児)',
    explain_13: '(仅支持：大人、小児、身障者大人、 身障者小児，填写其他价格种类不生效)',
    explain_14: '(请参照价格种类可用日期设置产品库存，设置不可用日期不生效，采购价不生效)',
    explain_15: '可用日期：',
    explain_16: '当前价格种类无可用日期',
    explain_17: '是否在售',
    explain_18: '价格规则设置说明：',
    explain_19: '乐天产品价格及日期填写说明：',
    explain_20: '请根据可用日期进行设置，设置不可用日期不生效，采购价不生效',
    isSale: '在售',
    notSale: '非在售',
    productDeleteMessage: '请先删除打包产品,或在打包产品中移除该产品!',
    none: '无',
    sendMailSet: '发团日前：',
    mailContent: '邮件内容：',
    noSend: '不发送',
    mailTime: '指定日期前',
    mailContent_placeholder: '请输入邮件内容',
    mailsetTips: '仅支持 无PDF电子票'
  },
  recharge: {
    depositWithdraw: '充值/提现',
    depositWithdrawHistoryRecord: '充值/提现历史记录',
    searchStr: '商户名/ID：',
    placeholder1: '请输入商户名/ID',
    businessType: '商户类型：',
    businessType1: '商户类型',
    placeholder2: '请选择',
    search: '搜索',
    businessName: '商户名称',
    businessName1: '商户名称：',
    balance: '余额',
    accountBalance: '账户余额：',
    operation: '操作',
    deposit: '手动充值',
    depositAuto: '在线充值',
    automatic: '自动充值',
    withdraw: '提现',
    record: '记录',
    withdrawAvail: '可提现金额：',
    withdrawAmount: '提现金额：',
    withdrawRemark: '提现备注：',
    cancel: '取 消',
    submit: '提交审核',
    depositAmount: '充值金额：',
    depositRemark: '充值备注：',
    all: '全部',
    supplier: '供应商',
    distributor: '分销商',
    submitSuccess: '提交成功',
    subimitFailed: '提交失败',
    message: '提现金额不能大于可提现金额！',
    goBack: '返回',
    dateRange: '选择时间段：',
    placeholder3: '选择日期范围',
    date: '日期',
    operator: '操作人',
    type: '类型',
    supplierWithdraw: '商户提现请求',
    platformWithdraw: '运营商提现',
    operationAmount: '充值/提现金额',
    remark: '备注',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    lastThreeMonth: '最近三个月',
    message2: '充值金额请输入正整数！',
    message3: '提现金额请输入正整数！',
    message4: '充值金额请输入小于2000,000,000的正整数！'
  },
  order: {
    batchSummary: '批次概要',
    canBeUseStartDate: '有效开始日期 ',
    canBeUseEndDate: '有效结束日期 ',
    createUserName: '采购者',
    bulkPurchase: '批量采购',
    remarks: '内部备注',
    orderSource0: '本系统',
    orderSource1: '供应商C端',
    orderSource2: '对外API',
    orderSource3: 'JTR',
    orderSource4: 'KLOOK',
    orderSource5: '易去',
    orderSource6: 'KKday',
    orderSource7: '稀客地图',
    orderSource8: '分销商C端',
    orderSource9: 'LINK',
    toCDistributorName: 'EasyGo BtoC',
    submitTime: '下单时间',
    sourceType: '订单来源',
    sourceJtr: 'JTR供应商',
    sourceJph: 'JPH供应商',
    allDate: '日期',
    productPrice: '单价',
    totalPrice: '总价',
    orderInfo: '订单信息',
    newSourceJtr: '运营者订单',
    payTime: '支付时间',
    productUseDate: '指定日期',
    cancelTime: '取消日期',
    keyWorld: ' 关  键  字',
    distributor: '分销商',
    secondAgentId: '二级代理商',
    secondAgentCommission: '二级代理商佣金',
    productArea: '商品所在地',
    supplier: '供应商',
    search: '搜索',
    synchronousTime_01: '（数据更新时间：',
    synchronousTime_02: '）',
    synchronousOrder_01: '同步订单',
    synchronousOrder_02: '(',
    synchronousOrder_03: 's)',
    validateTime: '验证日期',
    validateDate: '有效日期',
    expirationTime: '过期时间',
    timeSlot: '选择输入查询时间段',
    searchMsg: '订单ID/产品名称/客人姓名/客人邮箱/渠道单号',
    channelOrderId: '渠道单号',
    searchDistributor: '请输入分销商名称',
    searchSupplier: '请输入供应商名称',
    orderExport: '订单导出',
    ticketDepotExport: '票仓导出',
    ticketBatchDetailExport: '批次导出',
    productExport: '产品导出',
    productExports: '产品导出',
    orderId: '订单号',
    sonOrderId: '子订单号',
    productName: '产品名称',
    allBuyQuantity: '数量',
    customerName: '客户姓名',
    orderExplain: '订单备注说明',
    orderExplain1: '订单备注说明(此为内部备注，仅分销商内部可见)',
    orderStatus: '订单状态',
    notPay: '未支付',
    beConfirm: '待确认',
    beingCancel: '取消中',
    haveCanceled: '已取消',
    haveConfirmed: '已确认',
    beTicket: '待出票',
    batchHaveDone: '已完成',
    haveDone: '已完成',
    haveCancel: '已取消',
    haveRefundRequest: '已申请退款',
    haveRefund: '已退款',
    havePay: '已付款',
    failedPay: '支付失败',
    refuseRefund: '拒绝退款',
    haveTicket: '已出票',
    notPayButCanceled: '未支付取消',
    haveExpired: '已过期',
    leftHandleTime: '剩余处理时间',
    operation: '操作',
    addOrSub: '部分取消',
    refund: '退款',
    beAdd: '订单追加',
    addOrSubOrRefund: '部分取消/退款',
    source: '来源',
    validateOrder1: '核销成功',
    validateOrder2: '您没有核销此订单权限',
    validateOrder3: '核销失败',
    validateOrder4: '',
    date_empty: '日期错误，请重新选择',
    myouji_kana_empty: '姓氏格式不正确，请输入片假名或英文姓氏',
    namae_kana_empty: '名字格式不正确，请输入片假名或英文姓氏',
    bin_key_id_empty: '产品编号错误，请重新输入',
    sex_empty: '性别错误',
    tel_empty: '手机格式不正确，请输入10-11位数字',
    email_empty: '邮箱格式不正确，请输入正确的邮箱',
    total_num_empty: '预约人数错误',
    age_empty: '年龄格式不正确，请输入数字',
    emergency_phone_empty: '紧急连络电话错误',
    ctype_empty: '年龄、身障者分类错误',
    recep_empty: '预约已截止受理',
    num_over: '暂无可预订库存',
    num_not_sale: '选择的指定日期尚未开售',
    r_id_empty: '订单已取消',
    r_id_already_cancel_ok: '订单已取消',
    r_id_already_payment_ok: '订单已付款',
    thirdMethodErr: '合作商接口异常，请联络管理员',
    systemErr: '系统异常，请联络管理员'
  },
  jtrOrder: {
  },
  withdrawal: {
    withdrawalCash: '充值/提现',
    withdrawalCashManager: '充值/提现管理',
    withdrawalOnline: '在线充值',
    withdrawalOffline: '手动充值',
    applyWithdraw: '申请提现',
    beingHandel: '待处理',
    beingAudit: '待审核',
    notPass: '审核不通过',
    selectTimeSlot: '选择时间段',
    selectDateSlot: '选择日期范围',
    createTime: '创建时间',
    operationPeople: '操作人',
    type: '类型',
    recharge: '充值',
    withdraw: '提现',
    withdrawAmount: '提现金额',
    rechargeWithdrawAmount: '金额',
    rechargeWithdrawAmount2: '提现金额',
    remark: '备注',
    refundReason: '不通过理由',
    accountBalance: '账户余额',
    canWithdrawalBalance: '可提现金额',
    applyWithdrawalBalance: '申请提现金额',
    applyWithdrawalBalance2: '申请充值金额',
    selectWithdrawalAccount: '选择输入提现金额',
    withdrawRemark: '提现备注',
    withdrawRemark2: '充值备注',
    inputWithdrawRemark: '选择输入提现备注信息',
    cancel: '取  消',
    sure: '确  定',
    submitResigt: '提交申请',
    oneWeek: '最近一周',
    oneMonth: '最近一个月',
    threeMonth: '最近三个月',
    withdrawAmoutIsNotNull: '提现金额不能为空！',
    withdrawAmoutZS: '请输入正整数！',
    withdrawAmoutMustNumber: '提现金额必须是数字！',
    withdrawAmoutIsNot0: '提现金额必须大于0！',
    withdrawAmoutIsNotNegative: '提现金额不能为负数！',
    withdrawAmoutIsNotEnough: '可提现余额不足！',
    comformWithdrawMsg: '请确认提现信息,是否继续?',
    comformWithdrawMsgIfGo: '请确认提现信息,是否继续?',
    sureSubmit: '确认提交',
    returnEdit: '返回编辑',
    submitSuccess: '提交成功，等待审核！',
    companyName: '商户名称',
    companyName2: '商户名',
    companyType: '商户类型',
    distributor: '分销商',
    supplier: '供应商',
    inputCompanyNameAndId: '请输入商户名称/ID',
    handle: '处理',
    auditor: '审核',
    auditorPass: '审核通过',
    auditorNotPass: '审核不通过',
    withdrawHander: '提现处理',
    withDrawAuditor: '提现审核',
    withDrawAuditor2: '充值审核',
    withdrawHander2: '充值处理',
    refuseApply: '拒绝申请',
    refuseApplyReason: '请输入不通过理由',
    handlingSubmittingAudits: '处理并提交审核',
    handelSuccess: '处理成功！',
    rechargeFail: '充值失败'
  },
  password: {
    getPassword: '找回密码',
    pleaseInputMailAccount: '请输入邮箱账号',
    sendPasswordToMail: '发送密码到邮箱',
    returnToIndex: '返回',
    sendMsg: '输入您注册的业务负责人邮箱号，系统将初始化一个密码发送到对应的邮箱中。',
    mattersNeedingAttention: '注意事项',
    tips1: '请不要频繁的找回密码，一天最多使用',
    tips2: '次找回功能。',
    tipsMsg: '提示信息',
    loginAtonce: '马上登录',
    getUrlAgain: '重新获取',
    mailCanNotBeEmpty: '邮箱不能为空！',
    mailStyleNotRight: '请输入合法的邮箱格式！',
    mailHaveSendSuccess: '邮件发送成功,请去邮箱验证！',
    theMailInputNotExist: '输入的邮箱不存在！',
    theMailNotHaveRight: '该邮箱未激活或者被禁用！',
    aboveOneDayPermit: '超过一天允许操作的最大次数！',
    mailSendFail: '邮件发送失败！'
  },
  orderMessage: {
    pleaseIntoConfirmEmail: '请输入邮箱',
    emailError: '邮箱输入格式不正确',
    confirmEmailError: '确认单邮箱输入格式不正确',
    pleaseIntoUseDate: '请选择使用时间',
    pleaseIntprodDate: '请选择游玩时间',
    pleaseIntoHandDate: '请选择领取时间',
    pleaseIntoReturnDate: '请选择归还时间',
    pleaseIntoLinkCounter: '请选择领取柜台',
    pleaseIntoReturnCounter: '请选择归还柜台',
    pleaseIntoCustomEmail: '请输入游客姓名',
    pleaseSelectStock: '请选择场次',
    customEmailLength: '游客姓名长度不超过20',
    pleaseIntoCustomTel: '请输入游客手机号',
    pleaseIntoNationality: '请输入国籍',
    pleaseIntoBirthday: '请输入生日',
    customTelError: '游客手机号格式不正确',
    customTelError1: '游客手机号格式不正确,请输入10位或11位有效号码',
    customAgeError: '年龄格式不正确',
    customSexError2: '本产品为女性专用车辆，请重新选择性别',
    customSexError1: '本产品为男性专用车辆，请重新选择性别',
    pleaseIntoCustomWechat: '请输入游客微信',
    customWechatError: '游客微信格式不正确',
    pleaseIntoCustomPass: '请输入游客护照',
    customPassError: '游客护照格式不正确',
    pleaseIntoCustomAddress: '请输入快递地址',
    pleaseIntoCustomPostcode: '请输入邮政编码',
    customPostcodeError: '邮政编码格式不正确',
    pleaseIntoCustomCreditType: '请选择游客证件类型',
    pleaseIntoCustomCreditNo: '请输入游客证件号',
    customCreditNoError: '游客证件号格式不正确',
    customSexMale: '男',
    customSexFalmale: '女',
    customCtype1: '大人',
    customCtype2: '小児',
    customCtype3: '身障者大人',
    customCtype4: '身障者小児',
    pleaseRechangeCtype: '购买数量与乘车人类别不一致，请重新选择！',
    pleaseIntoCustomItem: '请输入游客自定义内容',
    quotaPrompt: '请输入大于0的整数',
    orderOnceBeOne: '单次订单预定数量至少为1',
    orderNumberOnceBeOne: '单次订单预定人数至少为1',
    orderStockBeMax: '本产品场次库存数至多为',
    orderOnceBeMax: '本产品单次订单预定数至多为',
    orderNumOnceBeMax: '本产品单次订单预定人数至多为',
    orderOnceBeMin: '本产品单次订单预定数量至少为',
    orderNumOnceBeMin: '本产品单次订单预定人数至少为',
    validateDateExpire: '有效日期已过期',
    productsNumError: '库存不足，订单无法生成',
    productsNumError1: '产品 ',
    productsNumError2: ' - ',
    productsNumError3: ' 库存不足',
    productsNumError4: ' PDF电子票库存不足',
    productPriceError: '价格已变化，请重新刷新',
    systemErrorMsg: '系统异常,请稍后再试!',
    pleaseUploadPDF: '需先上传PDF文件才能确认！',
    pleaseIntoUseData: '请输入指定日期',
    productUseDateBeNull: '订单的指定日期不能为空',
    jtrordermessage: '数量最多为',
    jtrplayDate: '请先选择游玩时间',
    jtrnum: '请选择数量',
    jtrphone: '请输入手机号',
    jtrphonefalse: '手机号不正确',
    linkCreditTypeErr: '请选择证件类型',
    linkCreditNoErr: '请输入证件号码',
    error: '订单无法追加、或已达到上限',
    limitedDate: '当前时间已超出产品预定时间范围,请重新下单!',
    limitBulking: '当前分销商正在批量采购中，暂时无法提交新的批次，请稍后再试!',
    designatedDateNull: '指定日期为空'
  },
  actuary: {
    all: '全部',
    actuaryType: '内容',
    actuaryType1: '预存款进款',
    actuaryType2: '请款书支付',
    actuaryType3: '临时采购',
    actuaryType4: '采购待支付',
    actuaryType5: '采购支付',
    actuaryType6: '售卖',
    actuaryState: '状态',
    actuaryState1: '正常',
    actuaryState2: '取消',
    actuaryState3: '完成',
    actuaryState4: '待处理',
    depositStatus0: '待处理',
    depositStatus1: '待审核',
    depositStatus2: '已完成',
    depositStatus3: '已拒绝',
    jphOrderStatus0: '待支付',
    jphOrderStatus1: '待确认',
    jphOrderStatus2: '取消中',
    jphOrderStatus3: '已取消',
    jphOrderStatus4: '已确认',
    jphOrderStatus5: '已完成',
    jphOrderStatus6: '未支付取消',
    jtrOrderStatus0: '待确认',
    jtrOrderStatus1: '待支付',
    jtrOrderStatus2: '已完成',
    jtrOrderStatus3: '取消订单',
    jtrOrderStatus4: '已付款',
    jtrOrderStatus5: '已申请退款',
    jtrOrderStatus6: '已退款',
    jtrOrderStatus7: '支付失败',
    jtrOrderStatus8: '拒绝退款',
    jtrOrderStatus9: '已出票',
    searchTime: '日期',
    searchWords: '关键字',
    searchMsg: '分销商名称/产品名称/设施',
    search: '搜索',
    exportExcel: 'Excel下载',
    addNew: '新增',
    actuaryId: '号码',
    createTime: '日期',
    facilitiesName: '设施',
    distributorName: '分销商',
    productName: '商品名',
    productNum: '张数',
    depositAmount: '预存款',
    payoutAmount: '支出',
    incomeAmount: '进价',
    saleAmount: '销售额',
    distributorBalance: '分销商预存款余额',
    salableQuantity: '可售张数',
    stockQuantity: '实际在库',
    operation: '操作',
    viewNum: '张数',
    viewNumErr: '张数不能为空或负数',
    view: '景点',
    viewIdErr: '景点必选',
    viewIdErr1: '只能选择一个景点',
    amount: '金额',
    amountErr: '金额不能为空',
    requestForm: '请求书',
    payDate: '支付日',
    payDateErr: '支付日不能为空',
    remark: '备考',
    remarkErr: '备考不能为空',
    validTime: '有效期',
    addAmount: '合计金额',
    money: '日元',
    confirm: '确认',
    timeSlot: '选择输入时间段',
    nameErr: '设施不能为空',
    validDateErr: '有效期不能为空',
    productInfo: '注 : 当前仅支持选择一种产品',
    productErr: '产品不能为空',
    productErr1: '当前只能选择一种产品',
    chooseActuaryType: '请选择新增精算类型',
    messageNotCompleteIn: '必要信息未输入完整',
    addSuccess: '添加成功',
    addError1: '添加失败,产品已存在或未选择产品',
    addError2: '添加失败',
    submitPrice: '价格不能为空!',
    submitMinPrice: '最低价格不能为空!',
    submitMinPrice0: '最低价格必须大于0!',
    submitMinPrice1: '分销价格必须大于0!',
    submitOrderNum: '排序不能为空!',
    submitLength: '价格及排序必须小于等于10位数字',
    addFailed: '系统异常,请稍后重试',
    operatorBalance: '余款',
    actuaryDetail: '精算详情'
  },
  finance: {
    calculatePeriod: '结算周期：',
    calculatePeriod1: '结算周期',
    placeholderCalculatePeriod: '选择结算周期',
    supplierNameAndId: '供应商名称/ID：',
    placeholderSupplierNameAndId: '请输入供应商名称/ID',
    search: '搜索',
    supplierName: '供应商名称',
    distributorPayoutAmount: '应付金额（JPY）',
    operatorIncomeAmount: '佣金金额（JPY）',
    supplierIncomeAmount: '结算金额（JPY）',
    operation: '操作',
    detail: '详情',
    downloadBill: '下载对账单',
    lastSixMonth: '近六个月',
    return: '返回',
    distributorName: '分销商名称：',
    distributorName1: '分销商名称',
    placeholderDistributorName: '请输入分销商名称/ID',
    finishTime: '完成时间',
    orderId: '订单号',
    productId: '产品编号',
    productName: '产品名称',
    productType: '产品类型',
    elecTicket: '电子票',
    paperTicket: '实体票',
    experTicket: '体验',
    daysTicket: '一日游/多日游',
    wifi: 'Wi-Fi',
    sim: 'SIM卡',
    restTicket: '美食',
    traffTicket: '交通',
    packTicket: '优惠套票',
    distributorPayoutAmount1: '应收佣金',
    operatorIncomeAmount1: '佣金金额',
    supplierIncomeAmount1: '结算金额'
  },
  payOrder: {
    payMessageOne: '请最终确认订单详情，订单在1小时内未支付将被取消。',
    payMessageOne1: '',
    payMessageOne2: '',
    payMessageOne3: '',
    jtrpayMessageOne: '请最终确认订单详情，订单在',
    jtrcancel: '取消部分订单',
    jtrAppend: '追加订单',
    jtrpayMessageTwo: '分钟内未支付将被取消。',
    payMessageTwo: '请尽快付款，否则产品售罄，订单无法购买。',
    payMessageThree: '订单在',
    payMessageFour: '分钟内未支付将被取消。',
    payMessageFive: '支付超时,请重新下单。',
    lineDownTicket: '线下电子票',
    lineUpTicket: '线上电子票',
    salaryByNow: '预付款支付',
    canBeUseMoney: '账户可用余额：',
    jtrcanBeUseMoney: '支付金额',
    remainTimes: '有效时间',
    payMoney: '支付：',
    applyCancel: '申请取消',
    payByNow: '立即支付',
    canBeUseMoneyError: '可用余额不足，订单无法生成',
    orderCanceled: '订单已取消',
    consentRefund: '已同意退款',
    refuseRefund: '已拒绝退款',
    overTimeByPay: '订单支付超时，自动取消',
    orderHaveUpdate: '支付失败，订单状态已更新',
    orderException: '订单异常，请重试',
    productException: '产品异常,无法编辑说明',
    payerror: '支付失败',
    error: '取消数量错误',
    applyerror: '申请失败'
  },
  supplyOrder: {
    confirmCancel: '确认取消',
    refuseCancel: '拒绝取消',
    canceleOrder: '取消订单',
    specialCanceleOrder: '特殊取消',
    partnerCancleOrder: '合作商接口取消',
    jtrSpecialCanceleChannel: '快速票单方取消',
    writeFff: '点击核销',
    confirmSpecialRefund: '确认特殊退款',
    refuseSpecialRefund: '拒绝特殊退款',
    orderConfirmDetail: '订单确认详情',
    system: '系统',
    checkedForNew: '点击查看新消息',
    orderRefuseMessage: '本产品属于不可退款产品,若申请取消，则支付款项不会退回，敬请知晓',
    canBeTakeBackFree: '退款手续费百分比',
    canBeTakeBack: '退款手续费',
    exchangeRate: '汇率差额',
    takeMoney: '实退金额',
    orderDetailByDialog: '订单确认详细',
    orderdetail1: '确认单①',
    orderdetail2: '确认单②',
    orderdetail3: '确认单③',
    orderdetail4: '确认单④',
    orderdetail5: '确认单⑤',
    orderdetail6: '确认单⑥',
    orderdetail7: '确认单⑦',
    orderdetail8: '确认单⑧',
    orderdetail9: '确认单⑨',
    fileTypes: '该文件非有效pdf格式！',
    reselectFile: '该文件内未包含PDF文件，请重新选择!',
    zipTypes: '该文件非有效zip格式！',
    fileSize: '上传pdf大小不能超过 5MB！',
    fileTypeBy: '文件名不能有逗号！',
    canCancel: '取消',
    downFiles: '下载文件',
    vailTimeMsg: '订单状态不支持修改有效期',
    vailTimelaterMsg: '结束日期不能小于当前日期',
    vailTimeFsjMsg: '富士急产品不支持修改有效期',
    vailTimeEmpty: '请选择有效期'
  },
  productNumberPrice: {
    pleaseIntoTime: '请选择时间',
    pleaseIntoNumber: '请填写库存',
    pleaseGetOneToSix: '请输入 1 到 6 个数字',
    pleaseIntoPurchasePrice: '请填写采购价',
    pleaseIntoDistorbutionPrice: '请填写分销价',
    pleaseIntoMarketPrice: '请填写市场价',
    dateCanotBeNull: '日期范围不能为空',
    confirmDateCanotBeMax: '设定时间段必须在产品上架时间段范围内！',
    distributorCanotBuyMessage: '暂时没有分销权限，不能购买此产品',
    distributorCanotBuyMessage2: '该产品已下线，不能购买此产品'
  },
  pwdSet: {
    pleaseIntoOldPwd: '请输入原密码',
    pleaseIntoNewPwd: '请输入新密码',
    pleaseConfirmPwd: '请确认新密码',
    pleaseIntoIntoSix: '请输入6-16位大小写英文字母或数字',
    mustBeOne: '必须跟上面输入的一致',
    pleaseIntoCorrectPwd: '请输入正确的密码',
    lengthMustOneToSix: '长度在 6 到 16 个字符',
    canotBeIntoNull: '不可输入空格和其他字符',
    updateNewPwdSuccess: '修改密码成功,请重新登录！',
    oldPwdError: '原密码错误，请重新输入！',
    oldAndNewNotOne: '两次输入密码不一致！',
    pleaseIntoMustItem: '请输入必输项',
    pleaseEnterPwd: '请输入密码',
    pleaseEnterPwdAgain: '请再次输入密码'
  },
  homeMessage: {
    urgnMessage: '您没有操作本功能的权限！'
  },
  entityTicket: {
    pinTicketNo: '核销票号',
    selectDepot: '选择仓库',
    pleaseSelect: '请选择',
    selectProduct: '选择产品',
    relationProduct: '关联产品',
    selectPriceType: '选择产品种类',
    saveTicketDepot: '保存票仓',
    onlySelectOnePro: '添加票仓一次只允许择一个产品!',
    onlySelectOnePriceType: '添加票仓一次只允许择一个产品种类!',
    depotNameNotBeEmpty: '仓库不能为空!',
    productNameNotBeEmpty: '产品不能为空!',
    productPriceTypeNotBeEmpty: '种类不能为空!',
    addSuccess: '添加成功!',
    inDepotSuccess: '入仓成功!',
    proHaveExist: '已经存在该产品!',
    selectDepotOut: '出仓仓库',
    selectDepotIn: '入仓仓库',
    depotProNum: '库存数量',
    validDate: '有效日期',
    selectDate: '选择日期时间',
    starEndTicketNo: '起止票号',
    starTicketNo: '起始票号',
    endTicketNo: '结束票号',
    inDepotTicketNo: '入仓票号',
    textArea: '单独扫码入口-将光标移到此处，然后用扫码枪扫实体票上的一维码',
    saveToDepot: '保存入仓',
    pleaseInputStarTicketNo: '请输入起始票号!',
    pleaseInputEndTicketNo: '请输入结束票号!',
    errorMsg01: '开始票号必须小于等于10位数字!',
    errorMsg02: '结束票号必须小于等于10位数字!',
    errorMsg03: '开始票号不能大于结束票号!',
    errorMsg04: '入仓票数量不能大于2000张!',
    errorMsg05: '以下票号长度大于10位',
    errorMsg06: '请选择入仓仓库!',
    errorMsg07: '出仓仓库和入仓仓库不能相同!',
    errorMsg08: '请选择到期时间!',
    errorMsg09: '请输入入仓票号!',
    errorMsg10: '该入仓仓库和该产品还没有建立票仓,请先建立票仓再进行产品入仓!',
    errorMsg11: '入仓仓库中存在以下票号',
    errorMsg12: '出仓仓库中以下票号不存在',
    errorMsg13: '该出仓仓库和该产品还没有建立票仓,请先建立票仓再进行产品出仓!',
    allBathList: '所有批次一览',
    batchDetailList: '批次详细一览',
    batchNO: '批次号',
    ticketNO: '票号',
    pleaseInputBatchNo: '请输入批次号',
    pleaseInputTicketNo: '请输入票号',
    inDepotTime: '入仓时间',
    inDepotUser: '入仓用户',
    importNumber: '导入数量',
    userNumber: '使用数',
    invalidateNumber: '作废数',
    leftNumber: '剩余数',
    exportNumber: '出库数',
    thisBatchDetail: '详细',
    clearDepot: '清仓',
    batchState: '批次状态',
    ticketState: '票状态',
    stateOne: '正常',
    stateTwo: '已使用',
    stateThree: '作废',
    stateFour: '已出库',
    stateFive: '已清仓',
    stateSix: '已锁定',
    userOperationTime: '使用（作废）时间',
    unUseRemark: '作废说明',
    orderId: '订单号',
    sureClearDepot: '确定对该批产品清仓吗?',
    sureClearDepot2: '确定对该产品清仓吗?',
    clearDepotSuccess: '清仓成功',
    haveCancelClearDepot: '已取消清仓操作!',
    invalidTicketSuccess: '全部作废成功!',
    addTicketDepot: '新增票仓',
    depot: '仓库',
    keyWorld: '关键字',
    inputProNameAndNo: '请输入产品名称/编号',
    userTimeQuantum: '使用时间段',
    inputSelectTimeQuantum: '选择输入查询时间段',
    depotId: '仓库ID',
    ticketDepotId: '票仓ID',
    depotName: '仓库名称',
    productId: '产品ID',
    productName: '产品名称',
    fileName: '文件总量',
    depotIn: '入仓',
    depotId2: '入库',
    depotId3: '→',
    depotId4: '初始入库',
    depotOut: '出库',
    history: '履历',
    zhang: '张',
    operationUser: '操作员',
    depotType: '仓库类型',
    addDepot: '新增仓库',
    inputDepotName: '请输入仓库名称',
    notAllDepot: '非总仓',
    allDepot: '总仓',
    depotRemark: '仓库备注',
    remarkMsg: '备注信息',
    inventoryNumber: '库存量',
    ifIsAllDepot: '是否为总仓',
    yes: '是',
    no: '否',
    tips: '注：总仓有且仅有一个',
    depotEdit: '编辑仓库',
    deleteDepot: '确定删除该仓库吗?',
    depotNameIsNotEmpty: '仓库名称不能为空!',
    allDepotOnlyOne: '总仓只允许有一个!',
    depotNameOnlyOne: '仓库名称已经存在!',
    userDepotManager: '用户仓库管理',
    addDepotToUser: '指定仓库',
    addDepotToUserSuccess: '指定成功!',
    notHistory: '该产品暂无履历!',
    pleaseSelectInvalidTicket: '请选择作废票号!',
    invalidTicketFalid: '全部作废失败!',
    someInvalidTicketFalid: '以下票号作废失败',
    orderQuery: '订单查询：',
    orderQueryPlac: '请输入订单号或扫码',
    orderInfo: '订单信息：',
    startStopNumber: '起止票号：',
    startNumber: '起始票号',
    stopNumber: '结束票号',
    numberEditPlac: '单独扫码入口-将光标移到此处，然后用扫码枪扫实体票上的一维码',
    confirmPin: '确认销票',
    formMsg1: '请输入验证码，订单号或扫码',
    rule_n1_10: '长度在 1 到 10 位数字',
    querySuccess: '查询成功',
    queryFailure: '该订单号不存在',
    queryMsg1: '起始票号不能大于结束票号，且最多一次只能销票100张',
    queryMsg2: '确认销票：',
    pinMsg1: '销票成功',
    pinMsg2: '销票失败!',
    clearRemark: '清仓备注'
  },
  ticketMessage: {
    pleaseEnterOrderId: '请输入订单ID',
    depotName: '仓库名称：',
    pleaseIntoDepotName: '请输入仓库名称',
    depotNameNotNull: '仓库名称不能为空',
    ticketRemark: '备注信息：',
    remarkNotNull: '备注信息不能为空',
    pleaseGetProduct: '请选择产品',
    fileDepotName: '文件库名称：',
    batchStatus: '批次状态：',
    batchId: '批次号',
    pleaseEnterBatchId: '请输入批次号',
    enterDate: '导入时间',
    enterUser: '导入用户',
    close: '关闭',
    Processing: '处理中',
    uploadFailure: '上传失败',
    ticketDetail: '详细',
    newToUse: '优先使用',
    fileStatus: '文件状态：',
    fileName: '文件名：',
    pleaseEnterFileName: '请输入PDF文件名',
    fileId: '文件ID',
    fileNames: '文件名称',
    downPdf: '下载PDF',
    ticketMessageBy: '以下票号的状态非正常，作废失败！',
    noUseMessage: '至少选择一个文件！',
    ticketMessageBy2: '本次操作存在状态为非正常的票，请刷新后重试！',
    operationSuccess: '操作成功!',
    getFile: '选取文件',
    getZipFile: '选取ZIP',
    getFilesOnlyFive: '限制上传PDF文件数量为5且单个文件大小限制10MB',
    getZipOnlyOne: '限制上传ZIP文件数量为1且单个文件大小限制300MB',
    usedDate: '有效截止日期：',
    usedDates: '有效截止日期',
    ticketMessageBy3: '为空则一直有效。',
    intoNow: '立即导入',
    intoSuccess: '导入成功!',
    insertFileDepot: '新增文件仓库',
    choose: '选择',
    fileDepotNames: '文件仓库名称',
    pleaseIntoFileName: '请输入仓库名',
    canBeUseDate: '使用（作废）时间段：',
    intoSearchDate: '选择输入查询时间段',
    into: '导入',
    fivePdf: '份PDF!',
    oneZip: '份ZIP!',
    ticketOpen: '打开',
    intoIng: '导入中,请稍候...',
    fileHadExists: '文件在仓库中已存在！',
    uploadSize: '上传图片大小不能超过 10MB！',
    uploadZipSize: '上传文件大小不能超过 300MB！',
    fileNotFors: '文件上传不可重复！',
    pleaseGetFile: '请选取文件',
    fileBatchRemarkNotNull: '请输入备注信息'
  },
  remind: {
    remindId: '序号',
    title: '邮件提醒',
    date: '发团日期',
    accessory: '附件',
    add: '新建提醒',
    upload: '上传邮件附件',
    beforeDay: '发团日前N天发送邮件提醒',
    before: '发团日前',
    days: '天发送邮件提醒',
    download: '下载附件',
    reminder: '提示',
    confirm: '确定',
    inputDate: '请输入发团日期',
    uploadAccessory: '请上传附件',
    inputbeforeDay: '请输入提前发送日',
    inputContent: '请输入邮件内容',
    sendContent: '发送内容',
    addRemind: '邮件提醒',
    existRemind: '当日提醒已存在',
    set: '邮件设置'
  },
  trades: {
    platform: '平台',
    excel: '导出EXCEL',
    tradesTime: '交易时间段',
    inputOrderId: '请输入订单号',
    tradingTime: '交易日期',
    operatorUser: '操作员',
    expenditure: '支出',
    income: '收入',
    buyQuantity: '数量',
    customerName: '客人姓名',
    orderExplain: '订单备注说明',
    content: '内容'
  },
  pinTicketMagn: {
    pinTime: '核销时间',
    pinTicket: '验证销票',
    shortcutOut: '快捷销票',
    all: '全部',
    validationType: '销票类型：',
    productName: '产品名称：',
    placeholder1: '请输入产品名称',
    validateTime: '销票日期：',
    placeholder2: '请选择销票日期',
    orderId: '订单ID：',
    placeholder3: '请输入ID',
    distributor: '分销商：',
    placeholder4: '请输入分销商',
    validationUser: '销票人：',
    placeholder5: '请输入销票人',
    ticketNo: '票号：',
    placeholder6: '请输入票号',
    colOrderId: '订单ID',
    colOrderContent: '订单内容',
    colValidateTime: '销票时间',
    colValidateType: '销票类型',
    colValidateUser: '销票人',
    colDistributor: '分销商',
    colCustomerOrderNo: '快捷销票单号',
    placeholder7: '请输入快捷销票单号',
    colCustomerOperator: '操作人',
    placeholder8: '请输入操作人',
    colticketNo: '票号',
    shortcutOutDepot: '销票仓库',
    shortcutOutProduct: '销票产品',
    company: '公司',
    orderIdNo: '单号',
    distributorNameAndOrderNo: '分销商名 (建议:可首字母) +单号',
    pleaseInputOrderCustomer: '请输入客户单号',
    pleaseInputCustomerOperator: '请输入操作人',
    shortcutOutSure: '确认销票',
    ticketCanNotBeCutOut: '以下票号不能被销票',
    ticketCanNotBeCutOuts: '请勿输入重复的票号',
    distributeOnlySelectOne: '分销商只能选择一个',
    ticketNumber100: '入票数量不能大于100!',
    pleaseInputDistribute: '请选择分销商!',
    pleaseInputOrder: '请输入单号!',
    orderLine100: '单号长度不能大于100个字符!',
    inputOperation: '请输入操作人!',
    operationLine100: '操作人长度不能大于100个字符',
    shortcutOutSuccess: '销票成功!'
  },
  errMsg: {
    errMsg100: '订单号不存在',
    errMsg101: '无对应的仓库',
    errMsg102: '仅业务员可销票',
    errMsg103: '订单不在有效期',
    errMsg104: '以下票号不能销票',
    errMsg105: '运营商或特殊权限的供应商直接选择审核通过操作失败',
    errMsg106: '产品ID不能为空',
    errMsg107: '上传文件不能为空',
    errMsg108: '服务器内部异常',
    errMsg109: '订单已经完成',
    errMsg110: '订单未确认',
    errMsg111: '销票数量与实际购买数量不符合',
    errMsg112: '无对应的票仓',
    errMsg113: '无对应的票',
    errMsg114: '请选择产品来源',
    errMsg115: '最少输入一个起止票号并确认',
    errMsg116: '该订单已取消',
    errMsg117: '该订单已过期',
    errMsg118: '',
    errMsg119: '',
    errMsg120: '',
    errMsg121: '正在处理中，请勿重复提交'
  },
  pay: {
    type: '充值方式',
    success: '支付已完成',
    fail: '支付未完成',
    toUrl: '请前往对应支付平台进行支付',
    toPay: '继续充值',
    error01: '支付拉起失败,请重试',
    error02: '支付已完成.请勿重复刷新.',
    loading: '支付数据处理中...',
    message: '支付成功后,入账因服务方会有些许延迟,请耐心等待'
  },
  pageSetting: {
    upload01: '只能上传jpg/png/jpeg文件，且不超过1MB',
    upload02: '首页图片尺寸1920x500像素，首页图片的元素图案需距左边430像素。',
    pageImg: '首页图片：',
    errorByPage01: '首页图片无变化',
    errorByPage02: '首页图片不能为空！'
  },
  barCode: {
    urlError: '地址链接异常!',
    getInfoError: '二维码获取异常!',
    productTextDescription: '详细说明',
    customerReceiveDate: '领取日期：',
    returnDate: '归还日期：',
    productUseDate: '指定日期：',
    buyQuantity: '购买数量：',
    productUseFlow: '使用流程：',
    productUseName: '姓名：',
    validityDate: '有效期限：'
  },
  supplementInfo: {
    urlError: '地址链接异常!',
    getSupplementInfo: '内容获取失败!',
    supplementOfUseFlow: '使用流程补充详细说明'
  },
  qrCode: {
    qrCodeSource: '名称',
    isDistribution: '分销',
    scale: '分佣比例',
    YES: '是',
    NO: '否',
    noValue: '暂无',
    distributionRange: '分销产品范围授权',
    distributionRangeAll: '全部二维码可分销',
    distributionRangeYes: '指定二维码可分销',
    distributionRangeNo: '除指定二维码外可分销',
    selectDistributor: '选择产品',
    tipMessage1: '请输入名称',
    tipMessage2: '请选择授权范围',
    tipMessage3: '请输入分佣比例',
    addError1: '二维码来源已存在，请重新输入',
    prompt: '确定删除该条二维码吗？',
    searchMore: '查看产品',
    choseCode: '选择二维码',
    choseCodeError: '请选择二维码',
    nickName: '昵称',
    auditStatus: '审核状态',
    submitAudit: '确定通过审核？',
    submitAudit1: '确定处理该提现？',
    cannotSale: '禁止以后，该用户将无法分销您的所有二维码产品',
    canSale: '启用以后，该用户将分销您的所有二维码产品',
    remark: '备注',
    agree: '通过',
    handle: '处理',
    notAgree: '拒绝',
    applyMoney: '提现金额',
    applyMoney1: '提现金额(已扣手续费)',
    chargeMoney: '手续费',
    aduitTime: '审批时间',
    aduitName: '审批人',
    remittanceExport: '汇款导出',
    realName: '账户名称',
    bankNo: '账户号码',
    bankName: '银行名称',
    branchName: '支行名称',
    accountType: '账户类型',
    tocDistributor: '所属分销商',
    distributorName: '二级分销商昵称',
    twoDistributor: '二级分销',
    oneDistributor: '分销商',
    drawaltip1: '提现金额超出账户余额',
    drawaltip2: '提现金额小于手续费',
    drawaltip3: '请输入要提现的金额',
    drawaltip4: '您有未处理的提现申请，请等待处理完成后继续提现',
    saleName: '分销用户',
    saleMoney: '二级分销收益',
    distributorMoney: '分销商收益',
    isHasMoney: '到账状态',
    isPay: '已到账',
    notPay: '未到账',
    handleStatus: '处理状态',
    handleStatus1: '待处理',
    handleStatus2: '已处理',
    handleStatus3: '已拒绝',
    handleBy: '处理人',
    handleTime: '处理时间',
    setCharge: '手续费设置',
    chargeConfirm: '您确定修改提现手续费？',
    accountStatus: '账户状态',
    canUse: '启用',
    cannotUse: '禁用',
    cannotUse1: '已解绑',
    incomeAmount: '收益金额',
    tocIncomeAmount: 'C端账户余额',
    withdrawalError1: '请输入账户名称',
    withdrawalError2: '请输入账户号码',
    withdrawalError3: '请输入银行名称',
    withdrawalError4: '请输入支行名称',
    withdrawalError5: '请输入账户类型',
    handleError1: '该用户余额不足，无法处理提现',
    handleError2: '提现处理操作只有运营商可以处理！',
    handleError3: '余额不足，无法处理提现',
    withdrawalTips: '10000JPY（包含10000）以上免手续费;10000JPY以下，收取手续费',
    withdrawalTips1: '10000JPY（包含10000）以上免手续费',
    withdrawalTips2: '10000JPY以下，收取手续费',
    applyCash: '提现申请',
    applyBy: '用户类型',
    applyUser: '申请人',
    twoApplyName: '二级分销商',
    cannotCharge: '设置的金额只能为正整数',
    name: '名称',
    Unbundling: '解绑',
    UnbundTips: '解绑成功后，该用户分销产品不再产生佣金。',
    cannotUnbund: '该用户有未入账的佣金，暂时无法解绑！',
    twoApplyNameID: '二级分销商ID',
    inputScale: '请输入分佣比例',
    keyTips: '二级分销商ID/二级分销昵称',
    saleLog: '查看直销记录',
    withdrawalTips4: '余额不足，暂不能提现'
  },
  payWay: {
    balance: '账户余额',
    weChat: '微信',
    alipay: '支付宝',
    creditCard: '信用卡',
    unionPay: '银联',
    weChatWay: '微信支付',
    payedId: '支付单号',
    alipayWay: '支付宝支付',
    isPay: '订单支付中',
    codeTips: '二维码已过期，请重新获取',
    codeTips1: '刷新二维码',
    codeTips2: '打开手机微信',
    codeTips3: '扫一扫二维码',
    codeTips4: '打开手机支付宝',
    codeTips5: '扫一扫继续付款',
    refundTips: '该订单已取消，您所支付的金额将退回原支付渠道，请注意查收',
    refundTips1: '该订单已支付，您所支付的金额将退回原支付渠道，请注意查收',
    refundTips2: '该订单使用第三方支付超过30天，暂不支持退款',
    refundTips3: '订单支付失败，如您已付款，您所支付的金额将退回原支付渠道，请注意查收',
    errorTips: '获取支付信息失败，请重新获取',
    payTitle: '合作商支付订单'
  },
  schedule: {
    scheduleListTitle: '定时任务列表',
    searchText: 'Bean名称/备注',
    addSchedule: '添加定时任务',
    editSchedule: '编辑定时任务',
    beanName: 'Bean名称',
    cronExpression: 'Cron表达式',
    params: '参数',
    remark: '备注',
    serverType: '执行类型',
    serverType_1: '单服务器',
    serverType_2: '全服务器',
    status: '状态',
    status_0: '正常',
    status_1: '暂停',
    inputBeanName: '请输入Spring Bean名称',
    beanNameMustNotNull: 'Bean名称不能为空',
    inputCronExpression: '请输入Cron表达式',
    cronExpressionMustNotNull: 'Cron表达式不能为空',
    run: '立即执行',
    stop: '暂停',
    resume: '恢复'
  }
}




// WEBPACK FOOTER //
// ./src/local/zh_cn.js